{
  "admin": {
    "title": "Control panel",
    "announcementManagement": "Announcements management",
    "auctionEndTime": "Auction endtime",
    "auctionManagement": "Auction management",
    "auctionsNotFound": "(Auctions not found)",
    "companyNotFound": "(Business not found)",
    "dealerUsers": "Dealer users",
    "editAuctionStatus": "Edit auction state",
    "editAuctionItem": "Edit auction info",
    "editAuctionEndTime": "Edit end time",
    "manageBids": "Manage bids",
    "auctionDetails": "View details",
    "rowActions": "Actions",
    "noMoreResults": "No more results",
    "resultsCount": "{{count}} results",
    "filteredResultsCount": "{{count}} / {{total}} results",
    "dataTable": {
      "emptyMessage": "No results",
      "loadingMessage": "Loading…",
      "toolbar": {
        "ariaLabel": "Table toolbar",
        "searchPlaceholder": "Search…",
        "quickSearchAriaLabel": "Quick search",
        "clearFilters": "Clear filters",
        "clearAllFiltersAriaLabel": "Clear all filters",
        "columns": "Columns",
        "allColumns": "All",
        "scrollBackLeft": "Back to left",
        "scrollRight": "Scroll right",
        "scrollTableLeftAriaLabel": "Scroll table left",
        "scrollTableRightAriaLabel": "Scroll table right",
        "rowHeightAriaLabel": "Row height",
        "densityCompact": "Compact",
        "densityStandard": "Standard",
        "densityComfortable": "Comfortable",
        "exportCsvTooltip": "Download as CSV",
        "exportCsvAriaLabel": "Export to CSV"
      },
      "filters": {
        "all": "All",
        "clear": "Clear",
        "apply": "Apply",
        "dateFrom": "From",
        "dateTo": "To",
        "numberMin": "Min €",
        "numberMax": "Max €",
        "allDates": "All dates",
        "allPrices": "All prices",
        "datePresets": {
          "today": "Today",
          "yesterday": "Yesterday",
          "last7": "Last 7 days",
          "last30": "Last 30 days",
          "thisMonth": "This month",
          "lastMonth": "Last month"
        },
        "numberPresets": {
          "under5k": "< 5,000",
          "5to15k": "5,000 – 15,000",
          "15to30k": "15,000 – 30,000",
          "over30k": "> 30,000"
        }
      },
      "header": {
        "resizeColumnAriaLabel": "Resize column width"
      }
    },
    "fetchNewestAuctions": "Find newest auctions",
    "fetchDraftAuctions": "Find draft auctions",
    "downloadBillingReport": "Download billing report",
    "noBillingReportYet": "No billing report is available yet.",
    "fetchUsers": "Find users",
    "login": "Log in as an admin user",
    "searchWithCompanyId": "Search by business ID",
    "searchWithCompanyName": "Search by business name",
    "searchWithEmail": "Search by email",
    "userNotFound": "(User not found)",
    "announcements": {
      "announcements": "Announcements",
      "edit": "Edit an announcement",
      "create": "Add an announcement",
      "startDate": "Announcement start time",
      "endDate": "Announcement end time",
      "content": "Content",
      "severity": "Severity",
      "audience": "Audience",
      "audienceHelper": "Limit the visibility of the announcement.",
      "deleteConfirmationTitle": "Are you sure you want to delete the announcement?"
    },
    "gdpr": {
      "title": "GDPR",
      "checkEmail": "Check email",
      "enterEmail": "Enter email",
      "errorMessage": "Email not found",
      "userData": "User data for {{email}}",
      "modal": {
        "title": "You are about to anonymize user data",
        "description": "Anonymization will replace the user's personal data with random strings. This action is irreversible.",
        "description2": {
          "firstMessage": "Anonymization cannot proceed if the auction is in the state ",
          "boldedText": "STARTED, ENDED, OFFER ACCEPTED or AWAITING FINAL OFFER."
        },
        "confirm": "Anonymize"
      },
      "tableDatas": {
        "service": {
          "title": "Service",
          "serviceName": "Baana"
        },
        "id": "ID",
        "firstName": "First name",
        "lastName": "Last name",
        "email": "Email",
        "phoneNumber": "Phone number",
        "role": "Role",
        "address": "Address",
        "city": "City",
        "country": "Country",
        "createdAt": "Created at",
        "auctions": "Auctions",
        "status": "Status",
        "startTime": "Start time",
        "endTime": "End time",
        "offerEndTime": "Offer end time",
        "vehicles": "Vehicles",
        "pdfConfirmationMessage": "This information was verified on {{currentDate}}"
      },
      "user": {
        "consumer": "Private"
      },
      "notification": {
        "userAnonymized": "User data anonymized",
        "userAnonymizationError": "Error anonymizing user data"
      }
    },
    "draftManagement": {
      "deleteInfo": "Delete draft",
      "delete": "Draft successfully deleted",
      "deleteConfirm": "Are you sure you want to delete the draft for vehicle {{regNo}}"
    },
    "auctionUpdate": {
      "error": "Error updating auction",
      "duplicateRegNo": "Registration number is already in use in another auction",
      "stateUpdated": "Auction state updated: {{state}}",
      "endTimeUpdated": "Auction end time updated",
      "bidDeclined": "Accepted bid declined",
      "itemUpdated": "Auction details updated"
    },
    "adminNotes": {
      "modalTitle": "Notes",
      "addPlaceholder": "Write a note…",
      "add": "Add",
      "save": "Save",
      "cancel": "Cancel",
      "edit": "Edit",
      "delete": "Delete",
      "deleteConfirmTitle": "Delete note?",
      "empty": "No notes",
      "loadError": "Failed to load notes",
      "saveError": "Save failed",
      "deleteError": "Delete failed",
      "openIcon": "Open notes",
      "menuAdd": "Add note",
      "createdAt": "Added: {{date}}",
      "updatedAt": "Edited: {{date}}",
      "validation": {
        "empty": "Note cannot be empty",
        "tooLong": "Note cannot exceed {{max}} characters"
      }
    },
    "auctionFlags": {
      "title": "Flags",
      "openTab": "Open",
      "resolvedTab": "Resolved",
      "empty": "No open flags",
      "emptyResolved": "No flags resolved in the last 30 days",
      "resolve": "Mark as resolved",
      "delete": "Delete flag",
      "cancel": "Cancel",
      "deleteConfirmTitle": "Delete this flag?",
      "resolved": "Flag marked as resolved",
      "deleted": "Flag deleted",
      "error": "Action failed",
      "notFound": "Could not find the flagged auction"
    },
    "auctionDetailsModal": {
      "seller": {
        "title": "Seller",
        "name": "Name",
        "email": "Email",
        "phoneNumber": "Phone number",
        "targetPrice": "Target price",
        "noTargetPrice": "No target price"
      },
      "dealer": {
        "title": "Bids",
        "name": "Name",
        "email": "Email",
        "businessName": "Business",
        "bid": "Bid",
        "status": "Status",
        "noBid": "No bids",
        "editBids": "Edit bids",
        "bidState": {
          "accepted": "Accepted",
          "declined": "Declined",
          "inProgress": "In progress"
        }
      },
      "vehicle": {
        "title": "Vehicle",
        "make": "Make",
        "model": "Model",
        "regNo": "Registration number",
        "regNoEmptyError": "Registration number cannot be empty",
        "vehicleType": "Vehicle type",
        "bikeType": "Moto type",
        "caravanType": "Caravan type"
      },
      "negotiationUser": {
        "seller": "Seller",
        "dealer": "Dealer"
      },
      "userRemoveModal": {
        "title": "Are you sure you want to delete {{firstName}} {{lastName}} from our service?",
        "description": "You are about to delete user {{firstName}} {{lastName}}"
      }
    },
    "patchesAndInfo": {
      "editMessage": "Send general instructions and updates",
      "patches": "Instructions & Updates"
    },
    "verticalChecks": {
      "title": "Vertical Checks",
      "description": "Check for potential missed commissions",
      "loading": "Loading vertical checks...",
      "error": "Error loading checks",
      "noResults": "No check results found",
      "summary": {
        "new": "{{count}} new",
        "reviewed": "{{count}} reviewed",
        "total": "Total {{count}} results"
      },
      "sections": {
        "new": "New Findings ({{count}})",
        "reviewed": "Reviewed Items ({{count}})"
      },
      "item": {
        "auctionId": "Auction ID",
        "regNo": "Registration Number",
        "yTunnus": "Business ID",
        "vertical": "Platform",
        "businessName": "Business Name",
        "listingDate": "Listing Date",
        "listingStatus": "Listing Status",
        "reviewedAt": "Reviewed At",
        "adLink": "Ad Link",
        "actions": {
          "markReviewed": "Mark as Reviewed",
          "viewAd": "View Ad",
          "viewAuction": "View Auction"
        }
      },
      "status": {
        "NEW": "New",
        "REVIEWED": "Reviewed",
        "FORSALE": "For Sale",
        "SOLD": "Sold",
        "RESERVED": "Reserved"
      },
      "verticals": {
        "nettiauto": "Nettiauto",
        "nettimoto": "Nettimoto"
      },
      "messages": {
        "markingAsReviewed": "Marking as reviewed...",
        "loadingAuction": "Loading auction details...",
        "markedAsReviewed": "Marked as reviewed",
        "failedToMark": "Failed to mark as reviewed",
        "failedToLoadResults": "Failed to load vertical check results",
        "auctionFetchError": "Error fetching auction details",
        "tryAgain": "Try Again",
        "refresh": "Refresh"
      },
      "labels": {
        "needsReview": "⚠️ NEEDS REVIEW",
        "reviewed": "✓ Reviewed",
        "unknown": "Unknown",
        "viewListing": "View Listing →",
        "needReview": "Need Review",
        "alreadyReviewed": "Already Reviewed",
        "noItemsNeedReview": "🎉 No items need review!",
        "allItemsReviewed": "All vertical checks have been reviewed.",
        "noReviewedItems": "No reviewed items yet."
      },
      "info": {
        "title": "What are Vertical Checks?",
        "description": "These are cars from NOT_SOLD auctions that have been found listed on Nettiauto/Nettimoto by the same Y-tunnus that was the highest bidder. This could indicate a missed commission.",
        "footer": "Reviewed items are automatically deleted after 30 days. Data refreshes every 5 minutes."
      }
    }
  },
  "auctionStates": {
    "seller": {
      "BILLED": "Billed",
      "CANCELLED": "Cancelled",
      "DELETED": "Deleted",
      "DRAFT": "Draft",
      "ENDED": "Ended",
      "NOT_SOLD": "Not sold",
      "OFFER_ACCEPTED": "Offer accepted",
      "SOLD": "Sold",
      "SENT_FOR_BILLING": "Sold",
      "STARTED": "Started",
      "REJECTED_BY_DEALER": "Buyer rejected"
    },
    "buyer": {
      "BILLED": "Billed",
      "CANCELLED": "Cancelled",
      "DELETED": "Deleted",
      "DRAFT": "Draft",
      "ENDED": "Waiting seller",
      "NOT_SOLD": "Not sold",
      "OFFER_ACCEPTED": "Accepted",
      "SOLD": "Deal completed",
      "SENT_FOR_BILLING": "Deal completed",
      "STARTED": "Auction started",
      "UNDER_NEGOTIATION": "Under negotiation",
      "REJECTED_BY_SELLER": "Offer rejected",
      "REJECTED_BY_DEALER": "Offer cancelled"
    },
    "admin": {
      "DRAFT": "Draft",
      "SENT_FOR_BILLING": "Sent for billing"
    }
  },
  "components": {
    "reliabilityIndicator": {
      "title": "Reliability",
      "level": {
        "2": "Good",
        "3": "Excellent"
      },
      "info": "Reliability reflects how accurately the price estimate could be calculated based on the market data available for your vehicle."
    },
    "targetPriceAlert": {
      "within": {
        "title": "Your price is on point",
        "body": "A good starting point – dealers consider the price realistic."
      },
      "below": {
        "title": "Your target price is below the estimate",
        "body": "The auction may raise the final price above your target."
      },
      "above": {
        "title": "Your target price is above the estimate",
        "body": "A high target price may reduce dealers' interest. Consider lowering your target within the estimate to get the best offers."
      }
    },
    "auctionItem": {
      "noNotes": "No notes",
      "note": "note",
      "note_other": "notes",
      "addNew": "Add new",
      "placeBid": "Place bid",
      "vehicleImageTargetPrice": "Target price",
      "copyRegno": "Register number {{regno}} copied to clipboard",
      "copyRegnoError": "Failed to copy registration number",
      "copyRegnoTooltip": "Copy",
      "quickAuction": "Quick",
      "hideAuction": "Hide auction",
      "showAuction": "Show auction",
      "auctionHidden": "Auction hidden",
      "auctionUnhidden": "Auction shown again",
      "oldAuction": "Old auction",
      "vehicleDataNotAvailable": "Vehicle information is no longer available.",
      "consumerVehicleDataNotAvailable": "Your old auction has been removed from our system. Create new auction",
      "createNewAuctionLink": "here",
      "endedInPlace": "Auction ended"
    },
    "auctionTimer": {
      "daysUnit": "day"
    },
    "biddingModal": {
      "bidSum": "Bid",
      "cancelButton": "Cancel",
      "containsPickup": "Bid contains pickup",
      "editBidTitle": "Edit bid",
      "highestBid": "Highest bid",
      "minimumBid": "Minimum bid",
      "minimumUpperLimit": "Minimum offer",
      "myBid": "My bid",
      "pickupRequired": "Please note that the price you are offering requires the vehicle to be picked up from seller",
      "placeBidButton": "Place bid",
      "placeBidTitle": "Placing a bid",
      "upperLimit": "Upper limit",
      "useBidMachine": "Use the bid machine",
      "bidTooHighWarning": "NOTE! You are making a significantly higher offer than the starting price or the highest offer is.",
      "guaranteedAmountActivated": "Guaranteed amount activated -",
      "guaranteedAmountNotActivated": "Guaranteed amount not activated in user settings",
      "toolTipHelp": "Activated guaranteed percentage",
      "alertHighestBidChanged": "A higher bid was just placed. New minimum bid is {{amount}}€. Please review your amount before submitting."
    },
    "bidMachineDeactivationModal": {
      "title": "Closing the bid machine",
      "verification": "Are you sure you want to close the bid machine?"
    },
    "bidMachineInfo": {
      "bidMachine": "Bid machine",
      "bidMachineMaxValue": "Upper limit",
      "guaranteedAmount": "Guaranteed amount"
    },
    "bidRow": {
      "highestBid": "Highest bid",
      "myBid": "My bid",
      "vatDeductible": {
        "title": "(Vat deductible)",
        "description": "VAT can only be deducted from the vehicle's operating or acquisition costs if the vehicle is acquired exclusively for business use that entitles to deduction. Even minor private use eliminates the entire right to deduct."
      }
    },
    "footer": {
      "aboutUsHeader": "About us",
      "baanaHeader": "Baana",
      "contact": "Contact us",
      "aboutUs": "About us",
      "termsOfUse": "Terms of use",
      "placeABid": "Sell your car",
      "continueAuction": "Continue filling information",
      "showAuction": "Show my auctions",
      "forConsumers": "For consumers",
      "forDealers": "For dealers",
      "faq": "FAQ",
      "userGuide": "User guide",
      "weBuyCars": "We buy cars",
      "weBuyCarsByMaker": "We buy car brands",
      "weBuyCarsByCity": {
        "helsinki": "We buy cars Helsinki",
        "espoo": "We buy cars Espoo",
        "vantaa": "We buy cars Vantaa",
        "turku": "We buy cars Turku",
        "tampere": "We buy cars Tampere",
        "oulu": "We buy cars Oulu"
      },
      "weBuyCarsByMakerLinks": {
        "audi": "We buy cars Audi",
        "bmw": "We buy cars BMW",
        "ford": "We buy cars Ford",
        "mercedesBenz": "We buy cars Mercedes-Benz",
        "nissan": "We buy cars Nissan",
        "opel": "We buy cars Opel",
        "skoda": "We buy cars Skoda",
        "toyota": "We buy cars Toyota",
        "volkswagen": "We buy cars Volkswagen",
        "volvo": "We buy cars Volvo",
        "tesla": "We buy cars Tesla"
      }
    },
    "markAsCompleteModal": {
      "title": "Marking a deal as completed",
      "paragraph1": "You are marking a deal as completed. Please check the agreed details and documents before doing so.",
      "paragraph2": "Once a deal has been marked as completed, it can no longer be cancelled or otherwise dealt with",
      "markAsComplete": "Mark as complete",
      "priceChangeReason": "Reason for price change",
      "salePrice": "Sale price"
    },
    "markOfferAcceptedModal": {
      "acceptConfirmation": "Are you sure you want to mark the auction as a preliminary deal?"
    },
    "notifications": {
      "BID_DECLINED": {
        "title": "Your offer has been declined",
        "content": "Seller of vehicle {{regNo}} declined your offer."
      },
      "ADMIN_BID_DECLINED": {
        "title": "Auction status updated",
        "content": "Support has updated the auction status. Your offer is no longer marked as accepted for vehicle {{regNo}}."
      },
      "ADMIN_BID_REMOVED": {
        "title": "Your bid has been removed",
        "content": "An admin has removed your bid for vehicle {{regNo}}."
      },
      "ADMIN_BID_MODIFIED": {
        "title": "Your bid has been modified",
        "content": "An admin has modified your bid for vehicle {{regNo}}."
      },
      "BID_UPDATED": {
        "title": "Offer updated",
        "content": "Dealership has updated their offer for vehicle {{regNo}}."
      },
      "BID_UPDATED_AND_STATE_CHANGE": {
        "title": "Congratulations on the deal!",
        "content": "As a result of your negotiation, the car dealership has changed its purchase offer from {{oldBid}} euros to {{newBid}} euros and marked the vehicle with license plate {{regNo}} as sold."
      },
      "BID_ACCEPTED": {
        "title": "Preliminary deal",
        "content": "The car dealership has marked the vehicle with license plate {{regNo}} as a preliminary deal."
      },
      "AUCTION_MARKED_SOLD": {
        "title": "Congratulations on the deal!",
        "content": "The car dealership has marked the vehicle with license plate {{regNo}} as sold."
      },
      "OFFER_WITHDRAWN": {
        "title": "Offer withdrawn",
        "content": "Dealership has withdrawn its offer for vehicle {{regNo}}."
      },
      "NEW_QUESTION": {
        "title": "New question",
        "content": "You have a new question about vehicle {{regNo}}."
      },
      "NEW_ANSWER": {
        "title": "New answer",
        "content": "Seller of vehicle {{regNo}} has answered your question."
      },
      "NEW_NEGOTIATION_MESSAGE": {
        "title": "New negotiation message",
        "content": "A new negotiation message has arrived for vehicle {{regNo}}."
      },
      "NEW_BIDS_OUTBIDDED": {
        "title": "Bid outbidded",
        "content": "Your bid for vehicle {{regNo}} has been outbidded."
      },
      "AUCTION_ENDED": {
        "title": "Bidding closed",
        "content": "Bidding for vehicle {{regNo}} has closed."
      },
      "FIRST_BID": {
        "title": "First bid",
        "content": "A first bid has been placed for vehicle {{regNo}}."
      },
      "TARGET_PRICE_REACHED": {
        "title": "Target price reached",
        "content": "A bid exceeding your target price has been placed for vehicle {{regNo}}."
      },
      "AUCTION_ADDITIONAL_INFO_ADDED": {
        "title": "Additional information added",
        "content": "Additional information has been added to the vehicle {{regNo}} you bid on, check the details here."
      },
      "REMINDER_TO_MARK_SOLD": {
        "title": "Reminder: mark the deal as completed",
        "content": "The offer for vehicle {{makeModel}} ({{regNo}}) has been accepted, but the deal has not yet been marked as completed. Please mark the deal as completed if the vehicle has already been handed over."
      },
      "age": {
        "days_one": "yesterday",
        "days_other": "{{count}} days ago"
      },
      "updateFailed": "Updating notification failed. Please try again or contact support",
      "generalFail": "Something went wrong. Please try again or contact support",
      "notifications": "Notifications",
      "noNotifications": "No notification",
      "markUnread": "Mark as unread",
      "markRead": "Mark as read",
      "markAllRead": "Mark all as read"
    },
    "negotiationModal": {
      "me": "Me",
      "seller": "Seller",
      "dealership": "Dealership",
      "sendMessage": "Send a message",
      "title": "Negotiation with the seller",
      "targetPrice": "Seller's target price:"
    },
    "auctionEditModal": {
      "markAsComplete": "Mark as complete",
      "paragraph1": "You are marking a deal as completed. Please check the agreed details and documents before doing so.",
      "paragraph2": "Once a deal has been marked as completed, it can no longer be cancelled or otherwise dealt with",
      "stateAndPriceEdit": "Auction state and price edit",
      "soldPrice": "Sold price",
      "ableToEditMessage": "You can still edit the purchase price",
      "successMessage": "Successfully edited state and price",
      "errorMessage": "An error occurred while editing state and price"
    },
    "notificationContainer": {
      "showAuction": "Show auction",
      "clickHere": "Click here"
    },
    "ourBidInfo": {
      "bidFromOurCompany": "Highest bid from our company: {{highestBid}}€",
      "bidMachineFromOurCompany": "(secured by bid machine up to maximum amount of {{maxAmount}}€)"
    },
    "quickRaise": {
      "confirmTitle": "Quick Raise",
      "confirmContent": "NOTE! Quick raises do not, by default, include pick-up. If you want to include pick-up in your offer, please go to user settings and enable \"Quick raise includes pickup\". This message will only appear once and in the future the raise will be immediate.",
      "buttonText": "Raise +{{minimumBidRaise}} €"
    },
    "rejectOfferDialog": {
      "title": "Rejecting an offer",
      "titleRejectQuestion": "Reject the offer?",
      "amountLabel": "Amount: {{amount}} €",
      "hintBeforeReject": "Before rejecting, you can suggest your own price.",
      "negotiateOnPrice": "Suggest a price",
      "content": "Are you sure you want to reject the offer?",
      "content2": "Are you sure you want to reject the offer without trying to negotiate? In the negotiation, you can suggest a price at which you would be willing to sell your car.",
      "negotiateButton": "Show negotiation",
      "negotiateButton2": "Start negotiation"
    },
    "rejectAllOffersDialog": {
      "title": "Decline all offers",
      "content": "Are you sure you want to decline all offers without trying to negotiate? You can suggest a price at which you would be willing to sell your vehicle in the negotiation.",
      "contentAfterNegotiation": "Are you sure you want to decline all offers?"
    },
    "searchPanel": {
      "inputPlaceholder": "Search by keywords",
      "searchButtonLabel": "Search"
    },
    "withdrawOfferModal": {
      "title": "Cancel the deal",
      "paragraph1": "Are you sure you want to cancel the deal?",
      "paragraph2": "Offers made on Baana are binding, provided that the vehicle matches the information given in the listing. If a deal cannot be reached, you can cancel the deal. Please note, however, that after cancellation, trading can no longer continue.",
      "reasonVisibilityInfo": "Please also state the reason for the cancellation. The reason for the cancellation is only visible to you and the administrator.",
      "reasonLabel": "Write the reason",
      "withdrawOffer": "Cancel the deal"
    },
    "articlePage": {
      "title": "How to sell your vehicle with Baana:",
      "watchVideo": "Watch video",
      "opensInNewTabAriaLabel": "{{linkText}} (opens in a new tab)",
      "step1": "Create a sales listing. The service guides you through creating the listing and taking photos step by step",
      "step2": "After you have published the listing, buyer dealerships have the opportunity to make offers until the end time. The competition does not bind you to sell.",
      "step3": "Choose the best offer after the bidding period ends. When you accept an offer, your contact information will be provided to the dealership that made that offer.",
      "step4": "The dealership will contact you and you can arrange the vehicle handover. The sale is done!",
      "moreArticles": "More articles in Baana"
    },
    "weBuyCarsPage": {
      "titleWithCity": "Cars are bought daily in Baana {{cityName.inessive}} - almost all car dealerships around Finland are buyers",
      "title": "Cars are bought daily in Baana - hundreds of car dealerships around Finland are buyers",
      "metaData": "Cars are bought daily in Baana! Sell your car to a dealership quickly at the best price. Compete dealerships at once and make deals even on the same day.",
      "metaDataWithCity": "Cars are bought {{cityName.basic}} - Cars are bought daily in Baana {{cityName.inessive}} and throughout Finland! Sell your car to a dealership quickly even on the same day, at the best price.",
      "metaTitle": "Baana - We buy cars",
      "metaTitleWithCity": "Baana - We buy cars {{cityName.basic}}",
      "subtitle": "Sell your car at the best price, even on the same day",
      "body1WithCity": "Baana is a car selling competition service, where you can compete for offers from car dealerships with one announcement {{cityName.inessive}}. Cars are bought in Baana by both large chains and small dealerships. Sell your car even on the same day at the fastest.",
      "body1": "Baana is a car selling competition service, where you can compete for offers from car dealerships all around Finland. Cars are bought in Baana by both large chains and small dealerships. Sell your car even on the same day at the fastest.",
      "title2": "All kinds of cars are bought in Baana",
      "body2": "Through Baana, both the most common cars on Finnish roads and rarer models are bought - competition is worthwhile regardless of the car!",
      "body3WithCity": "Through Baana, personal cars and vans, petrol cars, diesel cars, hybrid cars, electric cars, station wagons, minivans and many others are bought {{cityName.inessive}}.",
      "body3": "Through Baana, personal cars and vans, petrol cars, diesel cars, hybrid cars, electric cars, station wagons, minivans and many others are bought.",
      "title3": "Easy selling, reliable buyers",
      "body4": "Thanks to the competition, you always get the best price for your car, which car dealerships are currently paying. Selling is easy and reliable, as the dealership professionals take care of the paperwork for you.",
      "subtitleWithCity": "{{cityName.basic}} - cars are bought into these and many other dealerships {{cityName.inessive}}",
      "subtitle2": "These and hundreds of other dealerships are buyers in Baana:"
    },
    "weBuyCarsByMakerPage": {
      "titleWithMaker": "{{carMaker}} cars are bought daily in Baana - almost all car dealerships around Finland are buyers",
      "title": "Cars are bought daily in Baana - hundreds of car dealerships around Finland are buyers",
      "metaData": "Cars are bought daily in Baana! Sell your car to a dealership quickly at the best price. Compete dealerships at once and make deals even on the same day.",
      "metaDataWithMaker": "{{carMaker}} cars are bought - {{carMaker}} cars are bought daily in Baana! Sell your {{carMaker}} car to a dealership quickly even on the same day, at the best price.",
      "metaTitle": "Baana - We buy cars",
      "metaTitleWithMaker": "Baana - We buy {{carMaker}} cars",
      "subtitle": "Sell your car at the best price, even on the same day",
      "subtitleWithMaker": "{{carMaker}} - {{carMaker}} cars are bought into these and many other dealerships",
      "body1WithMaker": "Baana is a car selling competition service, where you can compete for offers from car dealerships all around Finland for your {{carMaker}} car. Cars are bought in Baana by both large chains and small dealerships. Sell your {{carMaker}} car even on the same day at the fastest.",
      "body1": "Baana is a car selling competition service, where you can compete for offers from car dealerships all around Finland. Cars are bought in Baana by both large chains and small dealerships. Sell your car even on the same day at the fastest.",
      "title2": "All kinds of cars are bought in Baana",
      "body2": "Through Baana, both the most common cars on Finnish roads and rarer models are bought - competition is worthwhile regardless of the car!",
      "body3WithMaker": "Through Baana, {{carMaker}} personal cars and vans, petrol cars, diesel cars, hybrid cars, electric cars, station wagons, minivans and many others are bought.",
      "body3": "Through Baana, personal cars and vans, petrol cars, diesel cars, hybrid cars, electric cars, station wagons, minivans and many others are bought.",
      "title3": "Easy selling, reliable buyers",
      "body4": "Thanks to the competition, you always get the best price for your car, which car dealerships are currently paying. Selling is easy and reliable, as the dealership professionals take care of the paperwork for you."
    }
  },
  "consumer": {
    "menu": {
      "articles": "Articles",
      "contactInfo": "Contact information",
      "faq": "Frequently asked questions",
      "login": "Login",
      "logout": "Logout",
      "newAuction": "New auction",
      "notifications": "Notifications",
      "ownAuctions": "My auctions",
      "toDealerView": "For dealers",
      "userSettings": "User settings"
    },
    "seo": {
      "homePage": {
        "title": {
          "car": "Baana - Compete car sales to dealerships - find the best price",
          "moto": "Baana - Compete motorcycle, moped, ATV, moped car or scooter sales to dealerships - find the best price",
          "caravan": "Baana - Compete motorhome, caravan or mobile home sales to dealerships - find the best price"
        },
        "description": {
          "car": "Sell your car to a dealership quickly, at the best price. Compete dealerships throughout Finland at once and make deals even on the same day.",
          "moto": "Sell motorcycle, moped, ATV, moped car or scooter to a dealership quickly, at the best price. Compete dealerships throughout Finland at once and make deals even on the same day.",
          "caravan": "Sell your motorhome, caravan or mobile home to a dealership quickly, at the best price. Compete dealerships throughout Finland at once and make deals even on the same day."
        }
      }
    },
    "auctionPage": {
      "editingDisabled": "Unfortunately, this auction cannot be edited."
    },
    "components": {
      "apiError": {
        "somethingWentWrong": "Something went wrong"
      },
      "deletePictureConfirm": "Are you sure you want to delete the picture?",
      "deletePictureQ": "Delete the picture",
      "errorOccurred": "Unfortunately, an error occured. Please try again later."
    },
    "homePage": {
      "cars": "Cars",
      "motoVehicleTypes": "Motorcycles, ATVs, snowmobiles",
      "caravanVehicleTypes": "Caravans and motorhomes",
      "carBasicInfoTitle": "Car basic info",
      "carConditionTitle": "Information on the condition of the car",
      "continueAuction": "Continue filling information",
      "CAR": {
        "instructionBullet1": "Fill in your car's details",
        "instructionBullet2": "Compete for offers from car dealerships",
        "instructionBullet3": "Sell to the highest bidder",
        "descriptionHeader": "Compete for offers from car dealerships all over Finland at once",
        "descriptionListItem-1": "Free service that does not obligate you to sell your car",
        "descriptionListItem-2": "You only need basic information and photos of your car",
        "descriptionListItem-3": "Sales even on the same day, reliable dealership buyers",
        "dealerLogoTitle": "These and hundreds of other dealerships as buyers",
        "instructionListItem-1-title": "Enter Basic Information",
        "instructionListItem-1-body": "To create a listing, you need the registration number and mileage. Your car is eligible for Baana if it has been driven less than 250 000 km and is registered in Finland. A motorcycle, moped, ATV, moped car, scooter or snowmobile is eligible for Baana if it has been driven less than 100,000 km.",
        "instructionListItem-2-title": "Take Photos",
        "instructionListItem-2-body": "The service guides you to add the required photos of your car (exterior and interior). We recommend adding other photos as comprehensively as possible, e.g., of the service book.",
        "instructionListItem-3-title": "Describe the Car's Condition",
        "instructionListItem-3-body": "Describe at least the condition of your car's tires and windshield in the listing. If the car has damages, mention them and add photos of them.\n\nYou can save the listing as a draft and complete it later.",
        "sellCarTitle": "Sell Your Car at the Best Price"
      },
      "MOTO": {
        "instructionBullet1": "Fill in your motorcycle's details",
        "instructionBullet2": "Compete for offers from buyers",
        "instructionBullet3": "Sell to the highest bidder",
        "vehicleTypes": "Motorcycle, ATV, scooter or snowmobile",
        "descriptionHeader": "Compete for offers from dealerships all over Finland at once",
        "descriptionListItem-1": "Free service that does not obligate you to sell your vehicle",
        "descriptionListItem-2": "You only need basic information and photos of the vehicle",
        "descriptionListItem-3": "Sales even on the same day, reliable dealership buyers",
        "dealerLogoTitle": "These and hundreds of other dealerships as buyers",
        "instructionListItem-1-title": "Enter Basic Information",
        "instructionListItem-1-body": "To create a listing, you need the registration number and mileage. Your motorcycle, moped, ATV, moped car, scooter or snowmobile is eligible for Baana if it has been driven less than 100,000 km and is registered in Finland.",
        "instructionListItem-2-title": "Take Photos",
        "instructionListItem-2-body": "The service guides you to add the required photos of your vehicle (exterior and any interior). We recommend adding other photos as comprehensively as possible.",
        "instructionListItem-3-title": "Describe the Vehicle's Condition",
        "instructionListItem-3-body": "Describe at least the condition of the tires and any windshield in the listing. If the vehicle has damages, mention them and add photos of them.\n\nYou can save the listing as a draft and complete it later.",
        "sellCarTitle": "Sell at the Best Price"
      },
      "CARAVAN": {
        "instructionBullet1": "Fill in your vehicle's details",
        "instructionBullet2": "Compete for offers from dealerships",
        "instructionBullet3": "Sell to the highest bidder",
        "vehicleTypes": "Motorhome, caravan, trailer",
        "descriptionHeader": "Compete for offers from dealerships all over Finland at once",
        "descriptionListItem-1": "Free service that does not obligate you to sell your vehicle",
        "descriptionListItem-2": "You only need basic information and photos of your vehicle",
        "descriptionListItem-3": "Sales even on the same day, reliable dealership buyers",
        "dealerLogoTitle": "These and hundreds of other dealerships as buyers",
        "instructionListItem-1-title": "Enter Basic Information",
        "instructionListItem-1-body": "To create a listing, you need the registration number and, for motorhomes, the mileage. Your motorhome, caravan or trailer is eligible for Baana if it is registered in Finland. Motorhomes must have been driven less than 250 000 km.",
        "instructionListItem-2-title": "Take Photos",
        "instructionListItem-2-body": "The service guides you to add the required photos of your vehicle (exterior and any interior). We recommend adding other photos as comprehensively as possible.",
        "instructionListItem-3-title": "Describe the Vehicle's Condition",
        "instructionListItem-3-body": "Describe at least the condition of the tires and any windshield in the listing. If the vehicle has damages, mention them and add photos of them.\n\nYou can save the listing as a draft and complete it later.",
        "sellCarTitle": "Sell at the Best Price"
      },
      "descriptionHeader": "Compete for offers from car dealerships all over Finland at once",
      "descriptionListItem-1": "Free service that does not obligate you to sell your car",
      "descriptionListItem-2": "You only need basic information and photos of your car",
      "descriptionListItem-3": "Deals even on the same day, reliable dealership buyers",
      "descriptionListItem-4": "You can accept or reject any offer",
      "descriptionListItem-5": "Deals with a reliable buyer. The car dealership handles the paperwork",
      "descriptionListItem-6": "Most dealerships will pick up the car from your home",
      "descriptionListItem-7": "Finnish service with Finnish-language customer support available on weekdays from 9 AM to 4 PM",
      "dealerLogoTitle": "These and hundreds of other dealerships as buyers",
      "faqBody": "The answer might be found in the frequently asked questions of the service.",
      "faqTitle": "Need help with creating the advertisement or have any other questions?",
      "instructionBullet1": "Fill in your car's details",
      "instructionBullet2": "Compete for offers from car dealerships",
      "instructionBullet3": "Sell to the highest bidder",
      "instructionListItem-1-title": "Enter Basic Information",
      "instructionListItem-2-title": "Take Photos",
      "instructionListItem-3-title": "Describe the Car's Condition",
      "showAuction": "Show My Competition",
      "start": "Start",
      "startAuction": "Start the Competition Here",
      "title": "Sell Your Car at the Best Price",
      "titleMain": "Sell Your Car",
      "titleEmphasis": "at the Best Price",
      "title2": "How to Create a Sales Listing",
      "sellCarTitle": "Sell Your Car at the Best Price",
      "articleBlockTitle": "Latest articles",
      "katsastusBanner": {
        "title": "An inspection makes your car more attractive",
        "subtitle": "You'll get a better price when the buyer knows your car's exact condition.",
        "ctaButton": "Read more"
      },
      "recentlySoldTitle": "Lately sold cars on Baana",
      "activeAuctionsBanner": {
        "title": "You have {{count}} active auction(s)",
        "andMore": "and {{count}} more",
        "viewAuctions": "View My Auctions"
      }
    },
    "myAuctions": {
      "republish": {
        "title": "Restart bidding",
        "cardBody": "You can still edit all the details of the advertisement before publishing."
      },
      "republishModal": {
        "title": "Check the listing details before republishing",
        "body": "You can still edit the listing before republishing it. Note: if you added information during the previous tender process, it will not be updated to the listing automatically.",
        "bodyNoAdditionalInfo": "In the next view, you can still edit the listing details before it is republished.",
        "bodyWithAdditionalInfo": "Additional information from the previous auction will not be transferred automatically. Please check and update it if necessary in the next step.",
        "previousInfoHeader": "Previous additional info:",
        "addedAt": "Added",
        "onlyImagesAdded": "Images added",
        "publish": "Review the listing",
        "errorText": "Republication failed. Please contact customer service."
      },
      "distanceBetween": "Distance from the buyer",
      "businessName": "Buyer",
      "pickup": "Pick up",
      "questions": {
        "notAnsweredYet": "(You haven't answered this question yet)",
        "answer": "Answer",
        "noQuestions": "(No questions)",
        "answerDeleted": "Answer deleted",
        "answerDeleteError": "Failed to delete the answer",
        "answerDelete": "Delete answer?",
        "answerSentSuccessfully": "Answer sent successfully",
        "answerSendError": "Failed to send the answer",
        "answerTheQuestion": "Answer the question",
        "writeAnswer": "Write an answer"
      },
      "userInfoMissingModal": {
        "title": "Update personal details",
        "text": "To accept the offer, please update your missing personal details. ",
        "textLink": "Read more about data requirements.",
        "taxIdentificationNumberInfo": "The tax identification number is not disclosed to any other party than the tax authorities."
      }
    },
    "wizard": {
      "common": {
        "validationSummaryTitle": "Please complete the items below before continuing",
        "targetPrice": "Target price"
      },
      "phoneNumberPlaceholder": "e.g. 0441234567",
      "title": "Sell your car effortlessly at the best price",
      "verticalPrefillNotFound": "Listing with registration number {{regNo}} was not found in {{source}}. Please check the registration number or fill in the information manually.",
      "verticalPrefillUnavailable": "Failed to fetch data from {{source}}. Please try again later or fill in the information manually.",
      "verticalPrefillDealerNotAllowed": "Car dealerships' cars cannot be listed on Baana",
      "verticalPrefillAlreadyHasAuction": "You already have an active auction, you cannot import a listing from {{source}}.",
      "verticalPrefillRegnoAlreadyInUse": "Registration number {{regNo}} is already in use in another active auction. You cannot create an auction with this registration number.",
      "existingDraftModal": {
        "title": "Log in to continue",
        "body": "Registration number {{regno}} already has an active draft or auction associated with email {{maskedEmail}}. Log in to continue or enter a different registration number.",
        "loginCta": "Log in",
        "clearRegnoCta": "Enter a different registration number"
      },
      "verticalImport": {
        "regNoLabel": "Registration number",
        "fetchButton": "Fetch data",
        "loginAndFetch": "Log in & Fetch data",
        "newBadge": "NEW",
        "car": {
          "buttonText": "Import data from {{source}} listing",
          "title": "Import {{source}} listing",
          "description": "Enter the {{source}} listing's registration number below and we'll automatically pre-fill what we can find. You can import cars driven <strong>less than 250,000 km</strong>.",
          "regNoHelper": "E.g. ABC-123"
        },
        "moto": {
          "buttonText": "Import data from {{source}} listing",
          "title": "Import {{source}} listing",
          "description": "Enter the {{source}} listing's registration number below and we'll automatically pre-fill what we can find. You can import motorcycles driven <strong>less than 100,000 km</strong>.",
          "regNoHelper": "E.g. AB-123"
        },
        "caravan": {
          "buttonText": "Import data from {{source}} listing",
          "title": "Import {{source}} listing",
          "description": "Enter the {{source}} listing's registration number below and we'll automatically pre-fill what we can find. You can import caravans driven <strong>less than 250,000 km</strong>.",
          "regNoHelper": "E.g. ABC-123"
        },
        "progress": {
          "title": "Transferring listing from {{source}}",
          "fetchingData": "Fetching data from {{source}}...",
          "creatingAuction": "Creating auction...",
          "transferringImages": "Transferring images...",
          "finalizing": "Finalizing..."
        },
        "success": {
          "completeDetails": "Complete the listing\n\nFill in the missing details, then the listing will be ready to publish on Baana"
        }
      },
      "auctionWizard": {
        "auctionAlreadyActive": "You have an active auction",
        "auctionUnfinished": "You have an unfinished auction. Continue filling out the auction.",
        "showAuctions": "Show My Auctions",
        "draftSavedSuccessfully": "Auction notice saved as a draft. You can continue filling it out later.",
        "draftSaveError": "Unfortunately, the draft could not be saved.",
        "resetAuctionVerificationModal": {
          "title": "Start a new listing",
          "description": "You have a listing in draft state. Do you want to continue the draft or create a new listing?",
          "resetAuctionButton": "Create new listing",
          "continueWithDraftButton": "Continue draft"
        },
        "leaveConfirmation": {
          "title": "Leave the listing?",
          "description": "Your progress is saved as a draft, and you can continue it later from My auctions. Do you still want to leave?",
          "leave": "Leave",
          "stay": "Continue draft"
        }
      },
      "moto": {
        "motoStepRegnoMileage": {
          "stepTitle": "Vehicle Information",
          "stepSubtitle": "Fill in your vehicle details",
          "stepHeading": "Vehicle Information",
          "orGiveBasicInfo": "OR give basic information",
          "labelRegnoExample": "Registration number (AB-123)",
          "mileage": "Odometer Reading",
          "licenseFormatError": "Check the format of the registration number",
          "licenseMissingError": "Check the registration number",
          "checkMileageError": "Check the mileage",
          "mileageZeroError": "The value must be greater than 0",
          "mileageOverError": "You can only auction vehicles with less than 100,000 km mileage"
        },
        "motoStepBasicVehicleInfo": {
          "stepTitle": "Vehicle information",
          "labelRegNo": "Registration number",
          "mileage": "Mileage",
          "mileageUnit": {
            "KM": "km",
            "H": "h"
          },
          "motoType": "Vehicle type",
          "type": "Type",
          "make": "Make",
          "model": "Model",
          "modelType": "Model detail",
          "modelYear": "Model year",
          "roadLegal": "Roadworthiness",
          "roadLegalOptions": {
            "roadLegal": "Roadworthy",
            "notRoadLegal": "Not roadworthy"
          },
          "firstRegistrationMonth": "First registration month",
          "firstRegistrationYear": "First registration year",
          "numberOfOwners": "Number of previous owners",
          "popularResults": "Popular",
          "otherResults": "Other",
          "snowmobileDemandWarning": "Demand for snowmobiles is currently low, so bids may not come. You can still submit the listing normally.",
          "mopedDemandWarning": "Demand for mopeds is currently low, so bids may not come. You can still submit the listing normally."
        },
        "motoStepTechnicalInfo": {
          "stepTitle": "Technical information",
          "driveType": "Drive type",
          "gearType": "Transmission",
          "engineSize": "Engine size",
          "powerClass": "Power class",
          "fuelType": "Engine type",
          "isCoSeater": "Side-by-side seating",
          "cooling": "Cooling",
          "trackWidth": "Track width",
          "coolingOptions": {
            "airCooled": "Air-cooled",
            "waterCooled": "Water/liquid-cooled"
          }
        },
        "stepBasicInfo": {
          "stepTitle": "Vehicle Information",
          "ownerInfo": "Ownership",
          "vehicleOwnershipSelf": "I own the vehicle myself",
          "vehicleOwnerShipOther": "I am listing on behalf of someone else",
          "vehicleOwnershipFinanceCompany": "The vehicle is owned by a finance company",
          "vehicleOwnershipBusiness": "Business owns the vehicle",
          "keyCount": "Number of keys",
          "maintenanceBook": "Maintenance book",
          "maintenanceBookPerfectBrand": "Complete brand maintenance book",
          "maintenanceBookPerfect": "Complete maintenance book",
          "maintenanceBookMaintainedNotByProgram": "* Maintained, but not according to maintenance program",
          "maintenanceBookIncomplete": "Incomplete maintenance book",
          "lastMaintenanceLabel": "Last maintenance year and month",
          "maintenanceBookNone": "None",
          "lastMaintenanceTitle": "Last maintenance",
          "lastMaintenanceYear": "Year",
          "lastMaintenanceMonth": "Month",
          "lastMaintenanceMileage": "Mileage",
          "lastMaintenanceUnknown": "Unknown",
          "lastMaintenanceUnknownInfo": "This information significantly affects how much a buyer is willing to offer for your vehicle. Are you sure you don't want to provide it?",
          "lastMaintenanceKms": "Please enter the mileage of the last maintenance",
          "lastMaintenanceKmsTooHigh": "Mileage must be less than the mileage of the vehicle: {{mileage}}",
          "clearMaintenance": "Clear maintenance",
          "lastInspection": {
            "title": "Last inspection date",
            "unknown": "Unknown",
            "notInspected": "Not inspected",
            "year": "Inspection year",
            "month": "Inspection month"
          }
        },
        "stepVehicleCondition": {
          "stepTitle": "Vehicle condition",
          "tireWear": "Tire condition",
          "tireWearNew": "New tires",
          "tireWearGood": "Good tires",
          "tireWearFair": "Fair tires",
          "tireWearBad": "Bad tires",
          "tireWearNone": "No tires",
          "trackWear": "Track condition",
          "trackWearNew": "New tracks",
          "trackWearGood": "Good tracks",
          "trackWearFair": "Fair tracks",
          "trackWearBad": "Bad tracks",
          "trackWearNone": "No tracks",
          "rimsHas": "Has rims",
          "rimsHasNone": "No rims",
          "windshieldConditionGood": "Good windshield",
          "windshieldConditionWornOut": "Worn windshield",
          "windshieldConditionStoneMark": "Stone chip in windshield",
          "windshieldConditionCracked": "Cracked windshield",
          "mileage": "Mileage",
          "mileageError": "The entered value is greater than the mileage",
          "engine": "Engine",
          "fuelSystem": "Fuel system",
          "electricalSystem": "Electrical system",
          "coldStartProblems": "Cold start problems",
          "frame": "Frame",
          "suspensionAndChassis": "Suspension and chassis",
          "track": "Track",
          "transmissionAndClutch": "Transmission and clutch",
          "brakes": "Brakes",
          "tiresAndSuspension": "Tires and suspension",
          "steering": "Steering",
          "exhaust": "Exhaust system",
          "fairings": "Fairings",
          "labelDamageFreeText": "e.g. seat covers torn.",
          "damageTitle": "Does your {{vehicleSubType}} have any of these damages?",
          "additionalDamageInfo": "You can provide more details or mention any other damages below. The service will also ask you to add pictures of the listed items."
        },
        "stepAccessories": {
          "accessoriesTitle": "Your vehicle's equipment level",
          "accessoryQuestion": "Does your vehicle have any of these additional accessories?",
          "additionalAccessoriesSubtitle": "You can optionally complement your vehicle's accessories.",
          "labelAccessoriesExamples": "e.g. Crash bars, pull start, hand guards",
          "trimLevelSubtitle": "Enter the name of your vehicle's equipment level. If you don't know the equipment level, leave this field blank.",
          "labelAccessoriesExamplesMotorcycle": "E.g. Crash bars, pull start, hand guards",
          "labelAccessoriesExamplesMoped": "E.g. Luggage rack, rear bag, hand guards",
          "labelAccessoriesExamplesMopedCar": "",
          "labelAccessoriesExamplesATV": "",
          "labelAccessoriesExamplesScooter": "",
          "labelAccessoriesExamplesSnowmobile": "E.g. Storage bags, GPS navigator, snow anchors",
          "motoSubTypeTextMotorcycle": "motorcycle",
          "motoSubTypeTextMoped": "moped",
          "motoSubTypeTextATV": "ATV",
          "motoSubTypeTextScooter": "scooter",
          "motoSubTypeTextMopedCar": "moped car",
          "motoSubTypeTextSnowmobile": "snowmobile",
          "motoSubTypeTextDefault": "vehicle",
          "motoSubTypeTextMotorcycle2": "motorcycle",
          "motoSubTypeTextMoped2": "moped",
          "motoSubTypeTextATV2": "ATV",
          "motoSubTypeTextScooter2": "scooter",
          "motoSubTypeTextMopedCar2": "moped car",
          "motoSubTypeTextSnowmobile2": "snowmobile",
          "motoSubTypeTextDefault2": "vehicle"
        },
        "stepAccessoriesMotorbike": {
          "12vOutlet": "12V outlet",
          "serviceBook": "Service book",
          "crashBars": "Crash bars",
          "heatedGrips": "Heated grips",
          "tractionControl": "Traction control",
          "antiLockBrakes": "Anti-lock brakes",
          "navigator": "Navigator",
          "backrest": "Backrest",
          "sideBags": "Side bags",
          "electricStart": "Electric start",
          "topCase": "Top case",
          "cruiseControl": "Cruise control",
          "adaptiveCruiseControl": "Adaptive cruise control",
          "ledAuxLights": "LED auxiliary lights",
          "gpsNavigator": "GPS navigator"
        },
        "stepAccessoriesATV": {
          "storageBoxes": "Storage boxes",
          "winch": "Winch",
          "snowPlow": "Snow plow",
          "skidPlate": "Skid plate",
          "offRoadTires": "Off-road tires",
          "ledLights": "LED lights",
          "towHitch": "Tow hitch"
        },
        "stepAccessoriesMoped": {
          "luggageRack": "Luggage rack",
          "smallTopCase": "Small top case",
          "chainGuard": "Chain guard",
          "heatedGrips": "Heated grips",
          "usbChargingPort": "USB charging port",
          "ledLights": "LED lights",
          "seatCover": "Seat cover",
          "footGuards": "Foot guards"
        },
        "stepAccessoriesScooter": {
          "seatBag": "Seat bag",
          "topCase": "Top case",
          "mirrors": "Mirrors",
          "weatherShield": "Weather shield",
          "handGuards": "Hand guards",
          "usbChargingPort": "USB charging port",
          "ledLights": "LED lights",
          "phoneMount": "Phone mount"
        },
        "stepAccessoriesSnowmobile": {
          "storageBags": "Storage bags",
          "cargoRacks": "Cargo racks",
          "heatedGrips": "Heated grips",
          "ledHeadlights": "LED headlights",
          "gpsNavigator": "GPS navigator",
          "skidPlate": "Skid plate",
          "deepSnowTracks": "Deep snow tracks",
          "snowAnchors": "Snow anchors"
        },
        "stepMedia": {
          "stepTitle": "Photos",
          "bulletListTitle": "Mandatory photos of the motorcycle, moped, quad bike, or scooter include:",
          "helpText": "If your vehicle has noteworthy scratches, damages, or deficiencies, it is also good to take pictures of them.",
          "damageDescriptionTitle": "Description of damages",
          "damageDetailsTitle": "You mentioned that your vehicle has the following damages:",
          "damagePictures": "Pictures of damages",
          "damagePicturesSubtitle": "If you add detailed pictures of damages or defects, you are 2.5 times more likely to sell your vehicle.",
          "labelAddPhoto": "Add photo",
          "labelMainPhoto": "Front",
          "labelDamagePhoto": "Photo of damage",
          "labelInterior": "Interior",
          "labelTrunk": "Trunk",
          "labelTyres": "Tires",
          "perspectiveBack": "Photo from back",
          "perspectiveBackAngle": "Photo from rear angle",
          "perspectiveDashboard": "Photo of dashboard with vehicle running",
          "perspectiveFront": "Photo from front",
          "perspectiveFrontAngle": "Photo from front angle",
          "perspectiveSideLeft": "Photo from left",
          "perspectiveSideRight": "Photo from right",
          "perspectiveFrontTire": "Photo of front tire",
          "perspectiveBackTire": "Photo of rear tire",
          "perspectiveRightTrack": "Photo of right track",
          "perspectiveLeftTrack": "Photo of left track",
          "perspectiveDashboardMoto": "Photo of instrument cluster",
          "photoTakingTips": "In addition to the required photos, we recommend adding at least a photo of your service book:",
          "stepDescription": "Add photos of your vehicle. The more comprehensive the photos, the more realistic offers you will receive.",
          "processingImages": "Processing images in the background. This may take a while.",
          "uploadProgress": "{{uploaded}} / {{total}} images uploaded",
          "aisaProcessingSingle": "Finishing image processing",
          "aisaProcessingMultiple": "Finishing images processing",
          "doNotRefreshWarning": "Please wait until all images are processed",
          "requiredPhoto": "* Required photo",
          "requiredPhotosMissingError": "Add all required photos",
          "imageTooBigError": "The image is too large. Maximum size is 15MB.",
          "imageTooLowQuality": "The image you added is of low quality. We recommend using sufficiently high-quality images so buyers can form an accurate impression of your vehicle.",
          "unsupportedMediaType": "Unfortunately, our service does not support the file type of the image you selected.",
          "damageReminderTitle": "You previously selected the following damages:",
          "minimumDamageImages": "At least {{count}} damage image(s) required",
          "requiredDamageImages": "Damage images are required",
          "titleFront": "Front",
          "titleBack": "Back",
          "titleLeftSide": "Left side",
          "titleRightSide": "Right side",
          "titleFrontTire": "Front",
          "titleBackTire": "Rear",
          "titleDashboardMoto": "Dashboard (running)",
          "titleRightTrack": "Right track",
          "titleLeftTrack": "Left track",
          "titleMaintenanceBook": "Service book",
          "titleChainAndSprocket": "Chain and sprockets",
          "brokenImagesWarning": "{{count}} image(s) failed to load. Please remove broken images before proceeding to the next step.",
          "brokenImageAutoRemoved": "1 broken image was automatically removed.",
          "brokenImagesAutoRemoved": "{{count}} broken images were automatically removed.",
          "refreshWarning": "Are you sure you want to refresh? Images are still being uploaded or processed.",
          "imagesProcessing": "Please wait while images are being processed..."
        },
        "stepFreeDescription": {
          "labelFreeDescription": "Free description",
          "stepSubtitle": "You can write a free-form description of your vehicle for your sales advertisement.",
          "stepTitle": "Your description of the vehicle",
          "stepHeading": "Free description of the vehicle"
        },
        "motoStepDelivery": {
          "delivery": "Delivery",
          "chooseDistance": "Choose the distance to which you are willing to deliver your vehicle.",
          "labelDeliveryWanted": "I want my vehicle to be picked up",
          "stepAdditionalInfo": "Note! If you are willing to deliver your vehicle yourself, you may likely get a better price for it.",
          "vatDeductible": "VAT deductible",
          "stepHeading": "Contact information and delivery",
          "targetPrice": "Target price",
          "targetPriceTooHigh": "The target price is too high"
        },
        "stepSummary": {
          "stepTitle": "My ad summary",
          "stepHeading": "My ad",
          "additionalAccessories": "Do you have any of these additional accessories in your vehicle?",
          "delivery": "Vehicle delivery after sale",
          "checkInfo": "Check that the information is correct. Then you can publish the ad!",
          "deliveryDistance": "Distance to which you are willing to deliver your vehicle",
          "descriptionNotProvided": "(description not provided)",
          "labelEditMileage": "Edit mileage",
          "ownership": "Ownership",
          "possibleDamages": "Possible damages",
          "trimLevel": "Equipment level",
          "deliveryPickup": "Vehicle is to be picked up",
          "editTargetPrice": "Edit target price",
          "publishConfirmation": {
            "modalTitle": "Confirm Publication & Duration",
            "areYouSure": "Are you sure you want to publish the ad?",
            "cannotEditAfterPublish": "Once published, you cannot edit the ad.",
            "durationTitle": "When would you like your auction to end?",
            "quickOption": "Quick competition (If sale is urgent)",
            "normalOption": "Normal (recommended)",
            "oneDayOption": "Next business day (24 hours)",
            "twoDaysOption": "In 2 business days (48 hours)",
            "sameDayOption": "Today (ends at 14-17)",
            "estimatedEndTime": "Estimated end time",
            "normalOptionInfo": "Ends in approx. 2 business days. Exact time shown after publishing."
          },
          "basicInfoTitle": "Vehicle basic information",
          "conditionTitle": "Vehicle condition",
          "accessoriesTitle": "Accessories",
          "usageHours": "Operating hours",
          "mileageUnit": {
            "KM": "km",
            "H": "h"
          },
          "errors": {
            "mileageRequired": "Mileage is required and must be greater than 0",
            "mileageTooHigh": "Mileage exceeds the maximum limit",
            "mileageLowerThanCurrent": "New mileage cannot be lower than the last maintenance mileage",
            "targetPriceRequired": "Target price is required and must be greater than 0",
            "targetPriceLowerThanCurrent": "New target price cannot be lower than the current price",
            "targetPriceTooHigh": "Target price cannot exceed 999,999"
          }
        }
      },
      "caravan": {
        "stepRegnoMileage": {
          "stepTitle": "Vehicle information",
          "caravanTypeLabel": "Vehicle type",
          "caravanTypeMotorhome": "Motorhome",
          "caravanTypeCaravan": "Caravan",
          "caravanTypeStorageTrailer": "Storage trailer"
        },
        "stepOwnerInfo": {
          "stepTitle": "Vehicle information",
          "stepTitleNew": "Vehicle information",
          "labelCarInfo": "Vehicle information",
          "stepSubtitleNew": "Check that the vehicle information is correct.",
          "popularResults": "Popular",
          "otherResults": "Other"
        },
        "stepBasicInfo": {
          "stepTitle": "Vehicle basic information",
          "moistureMeasurementTitle": "Has a moisture measurement been done on the vehicle?",
          "moistureMeasurementNo": "No",
          "moistureMeasurementYes": "Yes",
          "moistureMeasurementDescriptionLabel": "Tell here what and when",
          "moistureMeasurementHelperText": "You can also add a picture later",
          "amountOfKeys": "Number of vehicle keys",
          "lastMaintenanceKms": "Fill in the mileage of the last maintenance",
          "lastMaintenanceMonth": "Fill in the month of the last maintenance",
          "lastMaintenanceTitle": "Last maintenance mileage",
          "lastMaintenanceYear": "Fill in the year of the last maintenance",
          "lastMaintenanceUnknown": "This information significantly affects how much the buyer is willing to offer for your vehicle. Are you sure you don't want to enter it?",
          "lastMaintenanceLabel": "Year and month of last maintenance",
          "unknownLabel": "I don't know",
          "maintenanceBook": "How comprehensive is the vehicle's maintenance book?",
          "lastMaintenanceKmsTooHigh": "Mileage must be less than the vehicle mileage: {{mileage}}",
          "clearMaintenance": "Clear maintenance",
          "stepHeading": "Vehicle basic information",
          "vehicleOwnershipSelf": "I own the vehicle myself",
          "vehicleOwnerShipOther": "I am making the listing on behalf of someone else",
          "vehicleOwnershipFinanceCompany": "The vehicle is owned by a finance company",
          "vehicleOwnershipBusiness": "Business owns the vehicle",
          "amounOfKeysOne": "One",
          "amountOfKeysTwoOrMore": "Two or more",
          "maintenanceBookPerfectBrand": "Complete brand-specific service history",
          "maintenanceBookPerfect": "Complete service history",
          "maintenanceBookMaintainedNotByProgram": "Maintained, but not according to service program",
          "maintenanceBookIncomplete": "Incomplete service history",
          "maintenanceBookNone": "No service history",
          "incompleteMaintenanceBook": "You can specify missing details in the maintenance book",
          "lastInspection": {
            "title": "Last inspection",
            "year": "Year",
            "month": "Month",
            "notInspected": "Not inspected"
          }
        },
        "stepVehicleCondition": {
          "stepTitle": "Vehicle condition",
          "stepHeading": "Vehicle condition"
        },
        "stepDamages": {
          "stepTitle": "Possible damages",
          "labelDamageFreeText": "E.g. wipers don't work, fuel pump is broken, floor heating doesn't work",
          "smokedInQuestion": "Has the vehicle been smoked in?",
          "smokedInYes": "Yes",
          "smokedInNo": "No"
        },
        "stepAccessories": {
          "stepTitle": "Vehicle accessories",
          "modelDesignationLabel": "Model designation",
          "modelDesignationSubtitle": "What is written on the side of the caravan (maybe)",
          "accessoriesTitle": "Accessories",
          "accessories": "Accessories",
          "caravanAccessoriesSectionTitle": "Caravan accessories",
          "additionalAccessoriesSubtitle": "You can optionally complement your vehicle's accessories",
          "labelAccessoriesExamples": "e.g. Alde heat exchanger, Mover, Inverter, Li-Ion battery",
          "accessoryQuestion": "Does your vehicle have any of these additional accessories?",
          "trimLevelSubtitle": "Enter your vehicle's equipment level name. If you don't know the equipment level, leave this field empty.",
          "preselectedNote": "The following accessories have been automatically identified from your vehicle:"
        },
        "stepMedia": {
          "stepTitle": "Vehicle photos",
          "titleFrontAngle": "Front angle",
          "titleSide": "From the side",
          "titleBackAngle": "Rear angle",
          "titleInteriorFromEntrance": "Interior from entrance",
          "titleTowardsCabin": "Towards cabin",
          "titleFromDriverArea": "From cockpit",
          "titleSofaGroup": "Sofa group/Table group",
          "titleFromKitchen": "From kitchen",
          "titleToiletShower": "Toilet/shower",
          "titleBunkBeds": "Bed",
          "titleMoistMeasurement": "Moisture measurement"
        },
        "stepFreeDescription": {
          "stepTitle": "Vehicle free description",
          "stepHeading": "Free description of the vehicle",
          "stepSubtitle": "You can write a free-form description of your vehicle for your sales advertisement."
        },
        "stepDelivery": {
          "stepTitle": "Vehicle delivery",
          "stepHeading": "Contact information and delivery",
          "chooseDistance": "Choose the distance to which you are willing to deliver your vehicle.",
          "labelDeliveryWanted": "I want my vehicle to be picked up.",
          "stepAdditionalInfo": "Note! If you are willing to deliver your vehicle yourself, you may likely get a better price for it.",
          "targetPrice": "Target price",
          "vatDeductible": "VAT deductible",
          "targetPriceTooHigh": "The target price is too high"
        },
        "stepPriceEstimate": {
          "stepTitle": "Vehicle price estimate",
          "stepHeading": "Price estimate",
          "labelAccessories": "Accessories",
          "notFoundSubtitle": "Unfortunately, we cannot provide a reliable price estimate for your vehicle. However, you can provide a target price for your vehicle. The offers you receive from the competition correspond to the current market price of your vehicle.",
          "targetPriceInfo": "Next, provide the price at which you would be willing to sell your vehicle. Please note that setting a too high target price may reduce dealers' interest in your vehicle.",
          "checkTargetPriceError": "Check the target price",
          "targetPriceTooHigh": "The target price is too high",
          "fetchingPrice": "Fetching a price estimate for your vehicle...",
          "giveMakeAndModel": "Please provide your vehicle's brand and model.",
          "makeAndModelSelectionDesc": "We found several nearly identical models in our search results. Please verify your vehicle's exact model here.",
          "estimateNotFound": "Price estimate not found",
          "estimateDescription": "The price estimate is based on your vehicle's brand, model, model year and mileage.",
          "estimateAdditionalInfo": "Note! We are developing the price estimate tool. In some cases, the price estimate may be significantly higher or lower. By competing in Baana, you will receive the price that dealers are currently willing to pay for your vehicle.",
          "estimateBulletsInfo": "The following factors also affect the vehicle's purchase price:",
          "labelTyreHealth": "Tyre condition",
          "maintenanceHistory": "Accuracy and history of maintenance book",
          "paintCondition": "Paint condition and possible scratches",
          "windshieldCondition": "Windshield condition and possible defects",
          "vatDeductible": "VAT deductible"
        },
        "stepSummary": {
          "stepTitle": "Vehicle summary",
          "stepHeading": "My ad",
          "possibleDamages": "Possible damages",
          "checkInfo": "Check that the information is correct. Then you can publish the ad!",
          "vehicleDetailsTitle": "Vehicle details",
          "caravanType": "Vehicle type",
          "ownership": "Ownership",
          "trimLevel": "Equipment level",
          "additionalAccessories": "Accessories",
          "carDelivery": "Vehicle delivery after sale",
          "deliveryDistance": "Distance to which you are willing to deliver your vehicle",
          "deliveryPickup": "Vehicle is to be picked up",
          "descriptionNotProvided": "(description not provided)"
        }
      },
      "stepBasicInfo": {
        "amountOfKeys": "Number of car keys",
        "incompleteMaintenanceBook": "You can fill in missing information about maintenance book",
        "lastMaintenanceKms": "Fill in the mileage of the last maintenance",
        "lastMaintenanceMonth": "Fill in the month of the last maintenance",
        "lastMaintenanceTitle": "Last maintenance",
        "lastMaintenanceYear": "Fill in the year of the last maintenance",
        "lastMaintenanceUnknown": "This information significantly affects how much the buyer is willing to offer for your car. Are you sure you don't want to enter it?",
        "unknownLabel": "I don't know",
        "maintenanceBook": "How comprehensive is the car's maintenance book?",
        "stepTitle": "Basic information about the car",
        "lastMaintenanceKmsTooHigh": "Mileage must be less than the mileage of the vehicle: {{mileage}}",
        "clearMaintenance": "Clear maintenance",
        "stepHeading": "Basic information about the car",
        "vehicleOwnershipSelf": "I own the car myself",
        "vehicleOwnerShipOther": "I am making the listing on behalf of someone else",
        "vehicleOwnershipFinanceCompany": "The car is owned by a finance company",
        "vehicleOwnershipBusiness": "Business owns the vehicle",
        "amounOfKeysOne": "One",
        "amountOfKeysTwoOrMore": "Two or more",
        "maintenanceBookPerfectBrand": "Complete brand-specific service history",
        "maintenanceBookPerfect": "Complete service history",
        "maintenanceBookIncomplete": "Incomplete service history",
        "maintenanceBookNone": "No service history"
      },
      "stepDamages": {
        "additionalInfo": "You can provide more details or mention any other damages below. The service will also ask you to add pictures of the listed items.",
        "labelDamageFreeText": "e.g. Rear seat covers torn.",
        "paintDamage": "Paint damage",
        "stepTitle": "Do you have any of these damages in your car?"
      },
      "stepAccessories": {
        "accessoriesTitle": "Your car's equipment level",
        "accessoryQuestion": "Does your car have any of these additional accessories?",
        "additionalAccessoriesSubtitle": "You can optionally complement your car's accessories",
        "automaticAc": "Automatic air conditioning",
        "blockHeater": "Block heater",
        "cruiseControl": "Cruise control",
        "adaptiveCruiseControl": "Adaptive cruise control",
        "electricAdjustedSeating": "Electric adjusted seating",
        "gasHeater": "Gas heater",
        "hitch": "Tow hitch",
        "keylessIgnition": "Keyless ignition",
        "labelAccessoriesExamples": "e.g. Lane departure warning, alloy wheels, heated steering wheel",
        "labelTrimLevel": "Equipment level, e.g. Classic, Elegance, Business",
        "leatherInterior": "Leather interior",
        "metalColour": "Metallic paint",
        "navigator": "Navigation",
        "parkingSensor": "Parking sensor",
        "reversingCamera": "Reversing camera",
        "trimLevelSubtitle": "Enter your car's equipment level name. If you don't know the equipment level, leave this field empty.",
        "preselectedNote": "The following accessories have been automatically identified from your vehicle:",
        "preselectedAccessories": "Identified accessories",
        "accessories": "Accessories"
      },
      "stepDelivery": {
        "chooseDistance": "Choose the distance to which you are willing to deliver your car.",
        "labelDeliveryWanted": "I want my car to be picked up.",
        "stepAdditionalInfo": "Note! If you are willing to deliver your car by yourself, you may likely get a better price for it.",
        "stepHeading": "Car delivery method",
        "businessSection": "Business information",
        "officialName": "Official name of the business",
        "businessRegistryNumber": "Business registry number (Y-tunnus)",
        "vatNumber": "VAT number (optional)",
        "tinIssuingCountry": "Country of registration (ISO 3166-1 alpha-2)",
        "addressStreet": "Business street address",
        "addressPostalCode": "Business postal code",
        "addressCity": "Business city",
        "vehicleLocationSection": "Vehicle location",
        "vehicleLocationDescription": "Choose the sale location address or enter a different location.",
        "vehicleLocationCompany": "Vehicle is at the company address",
        "vehicleLocationCompanyChip": "Company address",
        "vehicleLocationCompanyDisabled": "Fill in business information above to enable this option",
        "vehicleLocationOtherTitle": "Other location",
        "vehicleLocationOtherDescription": "Enter a different address for this listing",
        "validation": {
          "invalidYTunnus": "Check the Y-tunnus",
          "invalidBusinessRegistryNumber": "Check the business registry number",
          "officialNameRequired": "Enter the company name",
          "businessRegistryNumberRequired": "Enter the business registry number",
          "tinIssuingCountryRequired": "Enter the country of registration",
          "addressStreetRequired": "Enter the street address",
          "addressCityRequired": "Enter the city",
          "vehicleStreetRequired": "Enter the street address",
          "vehicleCityRequired": "Enter the city"
        }
      },
      "stepFinished": {
        "buyersAllowedToBidCar": "Dealers can now make offers for your car.",
        "buyersAllowedToBidMoto": "Dealers can now make offers for your moto.",
        "buyersAllowedToBidCaravan": "Dealers can now make offers for your vehicle.",
        "labelPostSuccesful": "Your ad has now been published!",
        "acquisitionSurveyTitle": "How did you hear about Baana?",
        "acquisitionSurveyOptions": {
          "google": "Google",
          "socialMedia": "Social media (e.g. TikTok, YouTube, Instagram, Facebook)",
          "nettiauto": "Nettiauto",
          "bannerAd": "Saw banner ad",
          "tvAd": "Saw TV ad",
          "radioAd": "Heard radio ad",
          "article": "Through an article or news",
          "friend": "From a friend, family member, or acquaintance",
          "other": "Something else",
          "beelyLinkTitle": "Return to Beely"
        },
        "acquisitionSurveyOtherPlaceholder": "Tell us...",
        "acquisitionSurveyThankYou": "Thank you for your answer and good luck with the sale!",
        "submitAndShowAuction": "Submit and show ad"
      },
      "stepFreeDescription": {
        "labelFreeDescription": "Free description",
        "stepSubtitle": "You can write a free-form description of your car for your sales advertisement.",
        "stepTitle": "Your description of the car",
        "stepHeading": "Free description of the car"
      },
      "stepMedia": {
        "bulletListTitle": "Mandatory photos include:",
        "helpText": "If your vehicle has noteworthy scratches, damages, or deficiencies, it is also good to take pictures of them.",
        "damageDescriptionTitle": "Description of damages",
        "damageDetailsTitle": "You mentioned the following damages in your car:",
        "damagePictures": "Pictures of damages",
        "damagePicturesSubtitle": "If you add detailed pictures of damages or defects, you are 2.5 times more likely to sell your vehicle.",
        "labelAddPhoto": "Add photo",
        "labelDamagePhoto": "Damage photo",
        "labelInterior": "Interior",
        "labelTrunk": "Trunk",
        "labelTyres": "Tyres",
        "perspectiveBack": "Back view",
        "perspectiveBackAngle": "Back angle view",
        "perspectiveDashboard": "Dashboard view (car running)",
        "perspectiveFront": "Front view",
        "perspectiveFrontAngle": "Front angle view",
        "perspectiveFrontSeat": "Front seat view",
        "perspectiveSide": "Side view",
        "photoTakingTips": "In addition to the mandatory photos, we recommend adding pictures of the following as well:",
        "stepDescription": "Add pictures of your car. The more comprehensive the pictures, the more realistic offers you will receive.",
        "processingImages": "Processing images in the background. This may take a while.",
        "stepTitle": "Pictures of your car",
        "requiredPhoto": "(*Required)",
        "requiredPhotosMissingError": "Add all the mandatory photos.",
        "minimumImages": "At least {{count}} general photos are required",
        "requiredImages": "Images are required",
        "requiredPhotoCount": "Required photo count: at least {{count}}",
        "remainingPhoto": "Add one more photo",
        "remainingPhotosNeeded": "Add {{count}} more photos",
        "allRequiredPhotosAdded": "All required general photos added ✓",
        "allRequiredDamagePhotosAdded": "All required damage photos added",
        "uploadingImages": "Uploading images...",
        "uploadProgress": "{{uploaded}} / {{total}} images uploaded",
        "aisaProcessingSingle": "Finishing image processing",
        "aisaProcessingMultiple": "Finishing images processing",
        "doNotRefreshWarning": "Please wait until all images are processed",
        "imageTooBigError": "The image is too big. Maximum size allowed is 15MB.",
        "imageTooLowQuality": "The image you added is of low quality. We recommend using high-quality images to give buyers a proper view of your car.",
        "authenticatedHelpText": "You can proceed to take photos and come back to add them to the draft. Remember to save the draft at this point! You can return to the draft from 'My auctions'.",
        "unsupportedMediaType": "Unfortunately, our service does not support the selected image file type.",
        "damageReminderTitle": "You previously selected the following damages:",
        "multipleUploadInfo": "You can upload multiple images at once",
        "generalImages": "General images",
        "recommendedPhoto": "(Recommended)",
        "damageSectionTitle": "Damages",
        "otherImagesSectionTitle": "Other images",
        "otherImagesSectionExamples": "For example, add these photos:",
        "labelMainPhoto": "Front angle",
        "minimumDamageImages": "At least {{count}} damage image(s) are required",
        "requiredDamageImages": "Damage images are required",
        "titleFrontAngle": "Front angle",
        "titleSide": "Side",
        "titleFront": "Front",
        "titleBackAngle": "Back angle",
        "titleBack": "Back",
        "titleFrontSeat": "Front seat",
        "titleDashboard": "Dashboard (running)",
        "titleMaintenanceBook": "Service book",
        "titleTires": "Tires",
        "titleTrunk": "Trunk",
        "titleInterior": "Interior",
        "titleDamages": "Damages",
        "brokenImagesWarning": "{{count}} image(s) failed to load. Please remove broken images before proceeding to the next step.",
        "brokenImageAutoRemoved": "1 broken image was automatically removed.",
        "brokenImagesAutoRemoved": "{{count}} broken images were automatically removed.",
        "refreshWarning": "Are you sure you want to refresh? Images are still being uploaded or processed.",
        "imagesProcessing": "Please wait while images are being processed...",
        "cancelUploads": "Cancel uploads",
        "cancelingUploads": "Canceling image upload",
        "uploadsCancelled": "{{count}} image upload(s) cancelled successfully.",
        "uploadsCancelledWithKept": "{{cancelled}} image upload(s) cancelled. {{kept}} image(s) were kept as they were already successfully uploaded.",
        "allImagesProcessed": "All images have already been processed. Nothing to cancel.",
        "showExamples": "Show examples",
        "hideExamples": "Hide examples",
        "uploadsInProgress": "Image upload in progress",
        "aisaProcessing": "Images are still processing",
        "kuntoraportti": {
          "title": "A-Katsastus condition report",
          "toggleLabel": "Show report in listing",
          "included": "Report added to listing",
          "previewLabel": "Show report",
          "previewError": "Failed to open the report"
        }
      },
      "carousel": {
        "imageNotAvailable": "Image not available",
        "imageProcessing": "Image is being processed...",
        "loadingImage": "Loading image...",
        "imageDetailsMissing": "Image details missing",
        "takesMoment": "This may take a moment",
        "waitMoment": "Please wait a moment",
        "tryAgain": "Try again or reupload the images",
        "openLightbox": "Open image in lightbox view",
        "openLightboxWithIndex": "Open image {{index}} of {{total}} in lightbox view"
      },
      "stepOwnerInfo": {
        "labelBatteryCapacity": "Battery capacity",
        "labelBrand": "Brand",
        "labelCarInfo": "Car information",
        "labelContactInfo": "Contact information",
        "labelEngineSize": "Engine size",
        "firstRegistrationYear": "First registration year",
        "personsCount": "Number of persons",
        "labelRegNo": "Registration number",
        "mileage": "Mileage",
        "model": "Model",
        "modelYear": "Model year",
        "modelTypeName": "Model Type",
        "stepSubtitle": "Double-check that your car and contact information is correct.",
        "stepSubtitleNew": "Double-check that your car information is correct.",
        "stepTitle": "Car and contact information",
        "stepTitleNew": "Car information",
        "checkMunicipality": "Check the municipality.",
        "enterMunicipality": "Enter municipality.",
        "checkModelYearFormat": "Check the model year format.",
        "checkPhoneNumberFormat": "Check the phone number format.",
        "checkPhoneNumber": "Check phone number.",
        "enterPhoneNumber": "Enter phone number.",
        "checkPostalCode": "Check postal code.",
        "enterPostalCode": "Enter postal code.",
        "alreadyExistError": "Another Baana user already has an ad for this car. If you think this is a mistake, please contact support.",
        "youAlreadyHaveAuction": "You have an unfinished draft auction. Do you want to continue the draft or start fresh?",
        "errorMessage": {
          "checkMake": "Please provide the make of the car.",
          "checkModel": "Please provide the model of the car.",
          "checkFuelType": "Please provide the fuel type of the car.",
          "checkDriveType": "Please provide the drive type of the car.",
          "checkGearType": "Please provide the gear type of the car.",
          "checkModelTypeName": "Please provide the model type name of the car.",
          "checkModelYear": "Please provide the model year of the car.",
          "checkTargetPrice": "Check the target price.",
          "checkStreetAddress": "Check the street address",
          "enterStreetAddress": "Enter street address.",
          "checkCountry": "Check the country",
          "enterCountry": "Enter country.",
          "checkBatteryCapacity": "Please enter a valid battery capacity.",
          "batteryCapacityTooHigh": "The battery capacity is too high (max 1000 kWh).",
          "checkFirstRegistrationYear": "First registration year must be the same or newer than model year."
        }
      },
      "stepPriceEstimate": {
        "checkTargetPriceError": "Check the target price.",
        "targetPriceTooHigh": "The target price is too high",
        "estimateAdditionalInfo": "The price estimate is based on data from Nettiauto for the last 6 months. Please note that the estimate is based on the prices at which car dealers have sold the same model. The price that dealers are willing to pay for your car may be significantly lower. By competing in Baana, you will receive the price that car dealers are currently willing to pay for your car at most.",
        "estimateBulletsInfo": "Please note that the following factors also affect the car's purchase price:",
        "estimateDescription": "Note! We are currently developing the price estimate tool. In some cases, the price estimate may be significantly higher or lower. ",
        "estimateNotFound": "Set your own target price",
        "fetchingPrice": "Fetching a price estimate for your car...",
        "giveMakeAndModel": "Please provide your car's brand and model.",
        "labelAccessories": "Accessories",
        "labelTyreHealth": "Tyre Health",
        "maintenanceHistory": "Accuracy and history of maintenance book",
        "makeAndModelSelectionDesc": "We found several nearly identical models in our search results. Please verify your car's exact model here.",
        "notFoundSubtitle": "We cannot provide a reliable price estimate for your car. However, you can provide a target price for your car. The offers you receive from the competition correspond to the current market price of your car.",
        "paintCondition": "Paint condition and possible scratches",
        "priceFactorsTitle": "What affects the price?",
        "stepTitle": "Price estimate for your car",
        "targetPriceInfo": "Next, provide your own target price with VAT, at which you are willing to sell your car. Please note that setting a too high target price may reduce the interest of car dealers in your car.",
        "windshieldCondition": "Windshield condition and possible defects",
        "stepHeading": "Price estimate",
        "vatDeductible": "VAT deductible"
      },
      "stepRegno": {
        "labelRegnoExample": "Registration number (ABC-123)",
        "orGiveBasicInfo": "OR give basic information",
        "notFoundError": "Unfortunately, no car information was found with the provided registration number, please fill in the information manually.",
        "vehicleTooOldError": "Unfortunately, the selected car is too old to be sold on Baana.",
        "licenseFormatError": "Check the format of the registration number.",
        "licenseMissingError": "Check the registration number.",
        "checkMileageError": "Check the mileage.",
        "mileageZeroError": "Mileage must be greater than 0.",
        "mileageOverError": "You can auction cars driven less than 250,000 km.",
        "vehicleAgeCheckError": "The car's age could not be confirmed.",
        "youAlreadyHaveAuction": "You already have an auction with this registration number. You can edit your existing auction from your own listings.",
        "regnoAlreadyInUse": "This registration number is already in use in another auction.",
        "kuntoraporttiAvailable": "An A-Katsastus inspection report was found for this registration number. You can add it to the listing in step 7."
      },
      "stepSummary": {
        "businessContactMissing": "Please complete the business contact information before publishing.",
        "additionalAccessories": "Do you have any of these additional accessories in your car?",
        "carDelivery": "Car delivery after the deal",
        "checkInfo": "Now, make a final check that all the information is correct. Then you can publish the ad!",
        "deliveryDistance": "Distance to which you are willing to deliver your car",
        "descriptionNotProvided": "(description not provided)",
        "labelEditMileage": "Edit mileage",
        "ownership": "Car ownership",
        "possibleDamages": "Possible damages",
        "stepTitle": "Summary of your sales advertisement",
        "trimLevel": "Car's equipment level",
        "deliveryPickup": "Car must be picked up",
        "stepHeading": "Sales advertisement",
        "editTargetPrice": "Edit target price",
        "mileageUnit": {
          "km": "km"
        },
        "publishConfirmation": {
          "modalTitle": "Confirm Publication & Duration",
          "areYouSure": "Are you sure you want to publish the ad?",
          "cannotEditAfterPublish": "Once published, you cannot edit the ad.",
          "durationTitle": "When would you like your auction to end?",
          "quickOption": "Quick competition (If sale is urgent)",
          "normalOption": "Normal (recommended)",
          "oneDayOption": "Next business day (24 hours)",
          "twoDaysOption": "In 2 business days (48 hours)",
          "sameDayOption": "Today (ends at 14-17)",
          "estimatedEndTime": "Estimated end time",
          "normalOptionInfo": "Ends in approx. 2 business days. Exact time shown after publishing.",
          "sameDayHint": "Created before 10 AM: ends same day (2-5 PM). Otherwise, next business day."
        },
        "errors": {
          "mileageRequired": "Mileage is required and must be greater than 0",
          "mileageTooHigh": "Mileage exceeds the maximum limit",
          "mileageLowerThanCurrent": "New mileage cannot be lower than the last maintenance mileage",
          "targetPriceRequired": "Target price is required and must be greater than 0",
          "targetPriceTooHigh": "Target price is too high"
        }
      },
      "stepVehicleCondition": {
        "provideWindshieldInfo": "You can provide more details about the windshield condition below.",
        "summerTyreCondition": "Summer tire condition",
        "summerTyreRims": "Summer tire rims",
        "windshieldCondition": "Windshield condition",
        "windshieldInsurance": "I have windshield insurance",
        "winterTyreCondition": "Winter tire condition",
        "winterTyreRims": "Winter tire rims",
        "stepHeading": "Car condition information",
        "tireWearNew": "Like new",
        "tireWearGood": "Good",
        "tireWearFair": "Fair",
        "tireWearBad": "Bad",
        "tireWearNone": "None",
        "timingSystem": "Timing system",
        "timingSystemAttentionText": "You can optionally enter the last mileage at which the timing system was changed. This information helps buyers assess the condition and maintenance needs of the car.",
        "timingSystemInfo": "Timing system type",
        "timingSystemChanged": "Changed",
        "timingSystemBelt": "Belt (original)",
        "timingSystemBeltChanged": "Belt (changed)",
        "timingSystemChain": "Chain (original)",
        "timingSystemChainChanged": "Chain (changed)",
        "timingSystemUnknown": "Not known",
        "mileage": "Mileage",
        "mileageError": "The entered value is greater than the car's mileage",
        "rimsHas": "Has",
        "rimsHasNone": "None",
        "windshieldConditionGood": "Good",
        "windshieldConditionWornOut": "Worn out",
        "windshieldConditionStoneMark": "Stone mark",
        "windshieldConditionCracked": "Cracked"
      }
    },
    "emailNotifications": {
      "consumerAuctionEnded": "Auction ended",
      "consumerNewNegotiationMessage": "New negotiation message",
      "consumerQuestionAsked": "Question asked",
      "consumerAuctionStarted": "Auction started",
      "consumer15minWarning": "15 minutes remaining for auction to end",
      "consumerFirstBidNotification": "First bid",
      "consumerDealerRaisedBid": "Dealer raised the bid"
    },
    "smsNotifications": {
      "consumerAuctionEnded": "Auction ended",
      "consumerTargetPriceReached": "Target price reached",
      "consumerNewNegotiationMessage": "New negotiation message",
      "consumerQuestionAsked": "Question asked",
      "consumer4HourWarning": "4 hours left to accept the offer",
      "consumerDealerRaisedBid": "Dealer raised the bid"
    },
    "settingsPage": {
      "title": "User Settings",
      "phoneNumberTitle": "Phone Number",
      "notificationSettings": "Notification Settings",
      "sms": "SMS",
      "email": "Email",
      "updateSuccess": "Update Successful",
      "updateFail": "Update Failed",
      "phoneNumber": "Phone Number (personal)",
      "taxIdentificationNumber": "Tax identification number",
      "checkPhoneNumberFormat": "Check the phone number format",
      "checkIdentificationTaxNumberFormat": "Please provide the tax identification number in the correct format",
      "countryCode": "Country Code",
      "emailMessage": "Email is not editable"
    },
    "pageTitle": {
      "contactInfo": "Contact information",
      "home": "Home",
      "faq": "Frequently asked questions"
    }
  },
  "dealer": {
    "bulkMarkAsSold": {
      "markAsComplete": "Mark as complete",
      "acceptedDaysAgo": "Accepted {{count}} days ago",
      "acceptedToday": "Accepted today",
      "pageInstructions": "Mark the deal as complete if the vehicle has already been handed over."
    },
    "userActions": {
      "favourites": {
        "deleted": "{{regno}} removed from favourites",
        "added": "{{regno}} added to favourites",
        "add": "Add {{regno}} to favourites",
        "delete": "Remove {{regno}} from favourites",
        "error": "Failed to add {{regno}} to favourites"
      },
      "hide": {
        "deleted": "{{regno}} returned to visible",
        "added": "{{regno}} hidden",
        "error": "Failed to hide auction"
      }
    },
    "auctionDetailsPage": {
      "acceptedOffer": "Accepted offer",
      "accessories": "Accessories information",
      "newVehicleRemarks": "Additional information added to the listing after the listing was published",
      "accessoriesList": "Accessories",
      "vehicleAccessories": {
        "OUTLET_12V": "12V outlet",
        "SERVICE_BOOK": "Service book",
        "CRASH_BARS": "Crash bars",
        "HEATED_GRIPS": "Heated grips",
        "TRACTION_CONTROL": "Traction control",
        "ANTI_LOCK_BRAKES": "Anti-lock brakes",
        "NAVIGATOR": "Navigator",
        "BACKREST": "Backrest",
        "SIDE_BAGS": "Side bags",
        "ELECTRIC_START": "Electric start",
        "TOP_CASE": "Top case",
        "CRUISE_CONTROL": "Cruise control",
        "ADAPTIVE_CRUISE_CONTROL": "Adaptive cruise control",
        "STORAGE_BOXES": "Storage boxes",
        "WINCH": "Winch",
        "SNOW_PLOW": "Snow plow",
        "SKID_PLATE": "Skid plate",
        "OFF_ROAD_TIRES": "Off-road tires",
        "POWER_STEERING": "Power steering",
        "POWER_WINDOWS": "Power windows",
        "TOW_BAR": "Tow bar",
        "ALLOY_WHEELS": "Alloy wheels",
        "TWO_SETS_OF_TYRES": "Two sets of tyres",
        "AIR_CONDITIONING_MANUAL": "Manual",
        "AIR_CONDITIONING_AUTOMATIC": "Automatic",
        "INTERIOR_SOCKET": "Internal socket",
        "MOTOR_HEATER": "Motor heater",
        "LEATHER_UPHOLSTERY": "Leather upholstery",
        "ABS_BRAKES": "ABS brakes",
        "AIRBAG": "Airbag",
        "HUOLTOKIRJA_PAPER": "Paper",
        "HUOLTOKIRJA_ELECTRONIC": "Electronic",
        "SOUND_SYSTEM": "Sound system",
        "IMMOBILIZER": "Immobilizer",
        "ALARM_SYSTEM": "Alarm system",
        "SUNROOF_WITHOUT_PANORAMA": "Without panorama",
        "SUNROOF_WITH_PANORAMA": "With panorama",
        "ON_BOARD_COMPUTER": "On board computer",
        "CRUISE_CONTROL_TRADITIONAL": "Traditional",
        "CRUISE_CONTROL_ADAPTIVE": "Adaptive",
        "DRIVING_ASSISTANT": "Driving assistant",
        "REVERSING_CAMERA_SIMPLE": "Simple",
        "REVERSING_CAMERA_360": "360-degree camera",
        "CENTRAL_LOCKING_KEYLESS": "Keyless",
        "CENTRAL_LOCKING_REMOTE": "Remote control",
        "CENTRAL_LOCKING_WITH_KEY": "With key",
        "ELECTRIC_SEATS_WITHOUT_MEMORY": "Without memory",
        "ELECTRIC_SEATS_WITH_MEMORY": "With memory",
        "ROOF_OPENING_ELECTRONIC": "Electronic",
        "ROOF_OPENING_MANUAL": "Manual",
        "LED_LIGHTS": "LED lights",
        "TOW_HITCH": "Tow hitch",
        "LUGGAGE_RACK": "Luggage rack",
        "SMALL_TOP_CASE": "Small top case",
        "CHAIN_GUARD": "Chain guard",
        "USB_CHARGING_PORT": "USB charging port",
        "SEAT_COVER": "Seat cover",
        "FOOT_GUARDS": "Foot guards",
        "SEAT_BAG": "Seat bag",
        "MIRRORS": "Mirrors",
        "WEATHER_SHIELD": "Weather shield",
        "HAND_GUARDS": "Hand guards",
        "PHONE_MOUNT": "Phone mount",
        "STORAGE_BAGS": "Storage bags",
        "CARGO_RACKS": "Cargo racks",
        "LED_HEADLIGHTS": "LED headlights",
        "GPS_NAVIGATOR": "GPS navigator",
        "DEEP_SNOW_TRACKS": "Deep snow tracks",
        "SNOW_ANCHORS": "Snow anchors",
        "AIR_CONDITIONING_LIVING_AREA": "Air conditioning in living area",
        "GAS_STOVE": "Gas stove",
        "BUNK_BED": "Bunk bed",
        "AWNING": "Awning",
        "DOUBLE_BED": "Double bed",
        "SEPARATE_BEDS": "Separate beds",
        "ISLAND_BED": "Island bed",
        "DROP_DOWN_BED": "Drop-down bed",
        "FRIDGE": "Fridge",
        "ALDE_HEATING": "Alde (liquid heating)",
        "TRUMATIC_HEATING": "Trumatic (air)",
        "SOLAR_PANELS": "Solar panels",
        "INSULATED_GREY_WATER": "Insulated grey water",
        "FLOOR_HEATING": "Floor heating",
        "BIKE_RACK": "Bike rack",
        "MAINS_ELECTRIC_HEATING": "Mains electric heating",
        "CABIN_AC": "Air conditioning in cabin",
        "CASSETTE_WC": "Cassette toilet",
        "CASSETTE_CURTAINS": "Cassette curtains",
        "CARPETS_IN_BACK": "Carpets in living area",
        "CENTRAL_HEATING": "Central heating",
        "FREEZER": "Freezer",
        "HOT_WATER_TANK": "Hot water tank",
        "MICROWAVE_OVEN": "Microwave oven",
        "REAR_KITCHEN": "Rear kitchen",
        "SHOWER": "Shower",
        "SINK": "Sink",
        "ELECTRIC_STEP": "Electric step",
        "STABILIZER": "Stabilizer",
        "SUN_ROOF": "Sun roof",
        "TV_ANTENNA_OR_SATELLITE_DISH": "TV antenna or satellite dish",
        "FUEL_HEATER": "Fuel heater",
        "GENERATOR": "Generator",
        "ROOF_BOX": "Roof box",
        "DOUBLE_BOTTOM": "Double bottom",
        "FRONT_CANOPY": "Front canopy",
        "FRONT_TENT": "Front tent",
        "SERVICE_MANUAL": "Service manual",
        "tires": "Tires",
        "tracks": "Tracks",
        "trackWidth": "Track width (cm)"
      },
      "additionalInfo": "Additional information",
      "addNote": "Add note",
      "addNoteModal": {
        "title": "Add note",
        "enterMessage": "Enter your note"
      },
      "auctionEndsAt": "Auction ends at",
      "sellerTargetPrice": "Seller's target price",
      "batteryCapacity": "Battery capacity",
      "basicInfo": "Car's basic information",
      "engineSize": "Engine size",
      "vehicleBasicInfo": "Vehicle basic info",
      "bidMachineActive": "Bid machine is active.",
      "bodyType": "Body type",
      "condition": "Condition",
      "containsPickup": "Offer includes pickup.",
      "pickupIncluded": "Offer includes pickup.",
      "pickupNotIncluded": "Offer does not include pickup.",
      "coolingSystem": "Cooling system",
      "damageExtent": {
        "CRACK": "Crack",
        "DENT": "Dent",
        "FAULT_LIGHT": "Fault light",
        "PAINT": "Paint Damage",
        "SCRATCH": "Scratch",
        "UPHOLSTERY": "Upholstery damage",
        "MOISTURE_DAMAGE": "Moisture damage",
        "AIR_CONDITIONING": "Fault air conditioning",
        "ENGINE": "Engine",
        "FUEL_SYSTEM": "Fuel system",
        "ELECTRICAL_SYSTEM": "Electrical system",
        "TRANSMISSION_AND_CLUTCH": "Transmission and clutch",
        "BRAKES": "Brakes",
        "TIRES_AND_SUSPENSION": "Tires and suspension",
        "STEERING": "Steering",
        "EXHAUST": "Exhaust system",
        "FAIRINGS": "Fairings"
      },
      "damages": "Damages",
      "dealCompleted": "Deal completed",
      "deleteNoteTitle": "Delete note?",
      "delivery": "Seller is ready to deliver the car.",
      "vehicleDelivery": "Seller is ready to deliver the vehicle.",
      "deliveryLabel": "Delivery / pickup",
      "deliveryWithRange": "Seller is willing to deliver the car within {{range}}km.",
      "vehicleDeliveryWithRange": "Seller is willing to deliver the vehicle within {{range}}km.",
      "description": "Description",
      "descriptionNotProvided": "-",
      "doorCount": "Number of doors",
      "engine": "Engine",
      "driveType": "Drive type",
      "editNote": "Edit note",
      "gearType": "Gear type",
      "highestBid": "Highest bid",
      "isSideBySide": "Is side-by-side",
      "keyCount": "Number of keys",
      "lastMaintenanceLabel": "Last maintenance",
      "lastInspection": "Last inspection",
      "location": "Location and distance",
      "locationAndDelivery": "Location and delivery",
      "maintenanceBook": {
        "INCOMPLETE": "Incomplete",
        "MAINTAINED_NOT_BY_PROGRAM": "Maintained, not by program",
        "NONE": "Not available",
        "PERFECT": "Perfect",
        "PERFECT_BRAND": "Perfect, authorized service"
      },
      "maintenanceBookLabel": "Maintenance book",
      "moistureMeasurementLabel": "Moisture measurement",
      "moistureMeasurementDate": "Moisture measurement date",
      "moistureMeasurementPerformed": {
        "yes": "Yes",
        "no": "No"
      },
      "caravanType": "Vehicle type",
      "makeAnOffer": "Make an offer",
      "markOfferAccepted": "Mark deal as accepted",
      "markOfferAcceptedToolTip": "You can make a preliminary deal, after which the item will be moved to accepted items. Upon delivery of the car, you can still mark the deal as completed or cancel it if necessary.",
      "markDealAsComplete": "Mark deal as completed",
      "mileage": "Mileage",
      "mileageUnit": {
        "KM": "km",
        "H": "h"
      },
      "modelYear": "Model year / first reg. date",
      "myBid": "My bid",
      "ourBid": "Dealer's offer",
      "myBidRanking": "Ranking of my bid",
      "numberOfBids": "Total number of bids",
      "negotiationMessageLimit": "Please note that the length of the negotiation is limited to ten messages per party.",
      "negotiationMessageLimitReached": "You have used up the allocated message count. If the negotiation with the seller was significantly interrupted, please contact Baana customer support.",
      "noDamages": "No damages",
      "smokedIn": "Smoked in vehicle",
      "noNotes": "No notes.",
      "notes": "Notes",
      "notesInfo": "Notes are only visible for your own organization's users.",
      "noteHistory": {
        "title": "Previous notes",
        "mileageSince": "since",
        "loadError": "Failed to load previous notes.",
        "currentAuction": "This auction",
        "previousAuction": "Previous auction",
        "mileageThen": "Mileage then",
        "mileageNow": "Mileage now"
      },
      "questionsAndAnswersInfo": "Questions and answers are visible for all businessess",
      "notFound": "The requested item has been removed.",
      "backToAuctions": "Ongoing biddings",
      "notKnown": "Not known",
      "timingSystemNotChanged": "Not changed",
      "type": "Type",
      "offerDeal": "Offer deal",
      "offerEndsAt": "Seller's consideration period ends at",
      "startNegotiation": "Start negotiation",
      "openNegotiation": "Open negotiation",
      "ownership": {
        "FINANCE_COMPANY": "Finance company owns the car",
        "OTHER": "Other owner",
        "SELF": "Seller owns the car personally",
        "BUSINESS": "Business owns the car"
      },
      "vehicleOwnership": {
        "FINANCE_COMPANY": "Finance company owns the vehicle",
        "OTHER": "Other owner",
        "SELF": "Seller owns the vehicle personally"
      },
      "ownerCount": "Number of previous owners",
      "ownershipLabel": "Ownership",
      "personCount": "Number of people",
      "pickupOnly": "Seller requires pickup for the car.",
      "vehiclePickupOnly": "Seller requires pickup for the vehicle.",
      "power": "Power",
      "powerType": "Power type",
      "powerClass": "Power class",
      "registrationNumber": "Registration number",
      "sellerInfo": "Seller's information",
      "sellerToolTip": "Seller's information is only shown to the highest bidder.",
      "summerTires": "Summer tires",
      "timeLeft": "Time left",
      "tires": "Tires",
      "descriptionAndCondition": "Description and car's condition",
      "descriptionAndVehicleCondition": "Description and vehicle's condition",
      "tireWear": {
        "BAD": "Bad",
        "FAIR": "Fair",
        "GOOD": "Good",
        "NEW": "Like new",
        "NONE": "None"
      },
      "timingSystem": "Timing system",
      "timingSystemType": "Timing system type",
      "timingSystemChanged": "Timing system change time",
      "transmissionType": "Transmission type",
      "trimLevel": "Trim level",
      "withdrawalReason": "Withdrawal reason",
      "timingSystemCondition": {
        "CHAIN_ORIGINAL": "Chain",
        "CHAIN_CHANGED": "Chain",
        "BELT_ORIGINAL": "Belt",
        "BELT_CHANGED": "Belt",
        "UNKNOWN": "Unknown"
      },
      "windscreen": "Windscreen",
      "windscreenCondition": {
        "CRACKED": "Cracked",
        "GOOD": "Good",
        "STONE_MARK": "Stone Mark",
        "WORN_OUT": "Worn Out"
      },
      "winterTires": "Winter tires",
      "withdrawOffer": "Cancel the deal",
      "withRims": "With rims",
      "questions": {
        "notAnswered": "(Question has not been answered yet)",
        "title": "Questions and answers",
        "noQuestions": "No questions.",
        "add": "Add question",
        "deleteConfirm": "Delete question?",
        "edit": "Edit question",
        "writeQuestion": "Write your question",
        "answerDeleted": "Answer deleted",
        "questionDeletedByDealer": "Question deleted",
        "quickQuestions": {
          "question1": "Do you inspect the vehicle before sale?",
          "question2": "Has the timing system been changed?",
          "question3": "Would you like to provide more information about the maintenance book?"
        }
      },
      "reportAuction": {
        "button": "Report auction",
        "title": "Report auction to admins",
        "description": "Briefly describe why this auction needs the admin team's attention. The report will be sent to the Baana admins.",
        "reasonLabel": "Reason",
        "submit": "Send report",
        "limitReachedTooltip": "You have already reported this auction the maximum number of times."
      },
      "startPrice": "Starting price",
      "sendOffer": "Send offer",
      "raiseOffer": "You can still raise your offer",
      "windshieldInsurance": "Windshield insurance",
      "competition": {
        "title": "Other dealerships' bids",
        "businessName": "Business",
        "highestBid": "Highest bid",
        "numberOfBiddersLabel": "Unique bidders",
        "openCompetitionDetails": "Open competition details"
      },
      "viewKuntoraportti": "View condition report",
      "kuntoraporttiViewError": "Failed to open the condition report"
    },
    "loginPage": {
      "stockRefillNeeded": "Does your dealership need to replenish its stock?",
      "baanaOfferDescription": "With Baana, you can buy cars with less than 250,000 kilometers driven, caravans with less than 250,000 kilometers driven, and motorcycles, mopeds, ATVs, moped cars and scooters with less than 100,000 kilometers driven from consumers. You only pay for completed deals - no fixed costs. Most Finnish car and motorcycle dealerships are part of Baana.",
      "intrestedContact": "Interested? Contact us at:"
    },
    "menu": {
      "allActiveAuctions": "Ongoing biddings",
      "endedAuctions": "Ended auctions",
      "myAuctions": "My auctions",
      "instructionsAndUpdates": "Instructions & Updates"
    },
    "myAuctions": {
      "my": "My auctions",
      "company": "Our auctions"
    },
    "pageTitle": {
      "acceptedAuctions": "Accepted auctions",
      "allActiveAuctions": "Ongoing biddings",
      "allEndedAuctions": "All Ended auctions",
      "auctionsUnderNegotiation": "Auctions under negotiation",
      "closedAuctions": "Closed auctions",
      "declinedAuctions": "Declined auctions",
      "completedAuctions": "Completed deals",
      "contactInfo": "Contact information",
      "endedAuctions": "Ended auctions",
      "home": "Home",
      "myAuctions": "My auctions",
      "pendingAuctions": "Pending auctions",
      "instructionsAndUpdates": "Instructions & Updates"
    },
    "showHiddenAuctions": "Show hidden",
    "subHeaderTitle": {
      "acceptedAuctions": "Accepted",
      "auctionsUnderNegotiation": "Under negotiation",
      "pendingAuctions": "Pending",
      "declinedAuctions": "Declined",
      "completedAuctions": "Completed",
      "closedAuctions": "Closed",
      "all": "All"
    },
    "searchFilters": {
      "vehicleType": {
        "title": "Vehicle",
        "all": "All",
        "car": "Car",
        "moto": "Motorcycle",
        "caravan": "Caravan"
      },
      "bikeType": {
        "title": "Bike type",
        "noBikeTypesAvailable": "No vehicle types available"
      },
      "caravanType": {
        "title": "Caravan type"
      },
      "make": "Make",
      "modelYear": "Model year",
      "mileage": "Mileage",
      "info": "Filters are based on the information available for cars on sale.",
      "modelYearStart": "Starting from",
      "modelYearNoStartLimit": "No lower limit",
      "modelYearEnd": "Ending",
      "modelYearNoEndLimit": "No upper limit",
      "location": "Location",
      "sellerDelivers": "Seller is willing to deliver from further away",
      "targetPrice": "Target price",
      "sortOrderNewestFirst": "Newest first",
      "sortOrderOldestFirst": "Oldest first",
      "filterTitle": "Filter",
      "sameNameError": "Name for saved search is already used",
      "actionButtons": {
        "updateSearch": "Update saved search",
        "showResults": "Show",
        "saveSearch": "Save search",
        "clearSearch": "Clear search"
      }
    },
    "searchFilterGeneral": {
      "saveFilter": "Save New Search",
      "filterName": "Search Name",
      "savedFilters": "Saved Searches",
      "updateSavedFilter": "Update Saved Search",
      "hideCompanyAuctionFilter": "Hide auctions with company bids",
      "moreFilters": "+{{count}} others"
    },
    "searchFilterMessages": {
      "searchFiltersSaved": "Search criteria added successfully",
      "searchFiltersUpdatedSuccessfully": "Search criteria updated successfully",
      "searchFilterDeletedSuccessfully": "Search criteria deleted successfully"
    },
    "searchFilterModal": {
      "title": "Are you sure you want to delete saved filter?",
      "body": "Delete filter {{filterToBeDeleted}}"
    },
    "emailNotifications": {
      "dealerOfferAccepted": "Offer accepted",
      "dealerOutBidded": "Offer outbid",
      "dealerNewNegotiationMessage": "New negotiation message",
      "dealer5minWarning": "5 minutes remaining for auction to end",
      "dealer15minWarning": "15 minutes remaining for auction to end",
      "dealerAuctionDeleted": "Auction deleted",
      "dealerAuctionEnded": "Auction ended",
      "dealerDailyInfoEmail": "Ending auctions today"
    },
    "smsNotifications": {
      "dealerOfferAccepted": "Offer accepted",
      "dealerOutBidded": "Offer outbid",
      "dealerNewNegotiationMessage": "New negotiation message",
      "dealer5minWarning": "5 minutes remaining for auction to end",
      "dealer15minWarning": "15 minutes remaining for auction to end",
      "dealerQuestionAnswered": "Question answered"
    },
    "settingsPage": {
      "title": "User Settings",
      "phoneNumberTitle": "Phone Number",
      "notificationSettings": "Notification Settings",
      "pricingTitle": "Pricing",
      "pricingInfo": {
        "title": "Of the vehicle auction price",
        "body": "1% (alv. 0%)"
      },
      "pricingMin": {
        "title": "Minimum",
        "body": "100€ (VAT 0%)"
      },
      "pricingMax": {
        "title": "Maximum",
        "body": "400€ (VAT 0%)"
      },
      "sms": "SMS",
      "email": "Email",
      "updateSuccess": "Update Successful",
      "updateFail": "Update Failed",
      "phoneNumber": "Phone Number (personal)",
      "phoneNumberLabel": "Phone Number",
      "countryCode": "Country Code",
      "emailMessage": "Email is not editable",
      "bids": "Bids",
      "quickRaiseIncludePickUp": "Quick raise includes pickup",
      "bidAlwaysIncludePickUp": "Pickup always included in bids",
      "excludeOrganizationBidsTitle": "Auction filter",
      "excludeOrganizationBids": "Hide other company bids",
      "keepEndedAuctionsVisibleTitle": "Ended auctions",
      "keepEndedAuctionsVisible": "Show ended auctions in the listing view. They disappear when the browser refreshes.",
      "guaranteedAmount": {
        "title": "Guaranteed Amount for bid machine - How it works:",
        "example": "For example:",
        "instruction1": "You can choose a guaranteed amount for the bid machine feature, which will automatically increase your bid if it falls below the chosen level. The guaranteed amount is a percentage of the maximum limit set for the bid machine.",
        "instruction2": "You have selected 90% as the default level for your bid machine bids.",
        "instruction3": "You make a bid of 5000 € for a car and set the maximum limit for the bid machine to 10 000 €.",
        "instruction4": "You win the bidding with your first bid.",
        "instruction5": "Your bid of 5000 € is lower than 90% of the maximum limit set for the bid machine. Your bid will be automatically increased to 90% which is 9000 €.",
        "choosePercentage": "Choose the guaranteed amount for bid machine",
        "attention": "Note: This selection will apply to all the bids where you have enabled the bid machine feature. It cannot be changed during an ongoing bidding, only after it has ended."
      }
    }
  },
  "faq": {
    "mainTitle": "Frequently Asked Questions",
    "readMore": "Read More",
    "generalTitle": "General",
    "auctionInProgressTitle": "Auction in progress",
    "afterAuctionTitle": "After the auction",
    "financialTitle": "Financial Aspects",
    "salesProcessAndAuction": "Car, motorcycle or other vehicle bidding",
    "technicalQuestionsAndPreparation": "Vehicle information and pictures",
    "leavingAdAndControl": "Creating a listing",
    "timeTable": "How long does the auction last?",
    "content-1": "Baana is a free service for private users. When you sell your vehicle to a dealership through Baana competitive bidding, we charge a commission from the purchasing dealership.",
    "content-10": "All of Finland's largest dealerships buy through Baana. The service also includes many medium-sized and smaller dealerships. There are hundreds of buyer dealerships in total.",
    "content-11": "We recommend trying to clear your browser's cookies. If that doesn't help or you encounter other issues with the listing, our customer support will gladly assist you by phone at 0600 04070 (Mon-Fri 9 AM - 4 PM, Sat-Sun 11 AM - 3 PM, 0.38€/min + local call charge) or by email at asiakaspalvelu@almamobility.fi.",
    "content-12": "A traditional way to test your vehicle tire condition is to place a two-euro coin in the tire tread. You can also take close-up photos of your tires for your listing, allowing the dealership to assess their condition.",
    "content-13": "Windshields can get stone chips or, in the worst case, crack. Such damage is visible to the naked eye. A visual evaluation of the windshield condition is sufficient.",
    "content-14": "Repairing a vehicle will certainly increase its value. However, it depends on the case whether the repair value increases the price more than the repair costs. Dealerships often have good partners for vehicle repairs, so you can leave that to the buyer. Just remember to mention any faults needing repair in your listing so the dealership can take it into account in their offer.",
    "content-15": "After the deal, the vehicle handover can be done either by having the vehicle picked up or by delivering it to the dealership yourself. This information is in the listing for dealerships so they can prepare for possible pickup costs when making an offer. If you are willing to deliver the vehicle to the dealership yourself, you will likely get a slightly better price.",
    "content-16": "A phone camera is perfectly fine for taking pictures. The service will tell you which parts of the vehicle need photos and guide you in taking them. If your vehicle has something special, like damages, we recommend taking additional photos. The more comprehensively the vehicle is photographed, the better understanding the dealership will get of it. Remember to also take photos of the service book.",
    "content-17": "Yes, you can save an unfinished listing and continue filling it when it suits you best.",
    "content-18": "The dealership will contact you soon after you have accepted the offer. Please note that buyers may not be working on weekends, so contact may in some cases be delayed until the following week. If you still do not hear from the dealership, you can contact us by email at asiakaspalvelu@almamobility.fi.",
    "content-19": "If you are not satisfied with the offers you received, start a negotiation with your chosen dealership using start negotiation. In a negotiation, each party can send a total of 10 messages. The aim is to agree on a sale price so that the vehicle sale goes through.",
    "content-20": "Absolutely. Selling a relatively new car, motorcycle, or for example an ATV through Baana is worthwhile, as these are often the most interesting, especially from the perspective of large car dealership chains. At best, several dealerships are interested in your vehicle, and through the competitive bidding process for selling your car, motorcycle or other vehicle, the price you receive increases.",
    "content-21": "The easiest way is to sell your car, motorcycle, or other vehicle through Baana and use this money for the vehicle exchange. Usually, the best outcome for the seller is achieved when the old vehicle is sold and the new one is bought separately. This way, you get good capital from your old vehicle for buying a new one and can purchase it from any dealership.",
    "content-2": "In Baana, you can get a free price estimate for your car when submitting a listing. The price estimate is based on average prices, so please note that the estimate may differ from the actual value, as each car is unique. If a price estimate cannot be generated for your car, it is usually because your car is either too new or too rare for enough data to be available.<br/><br/>{{link1}}<br/><br/>There is no price estimate available for vehicles other than cars. The best estimate of the selling price you can get by competing for offers in Baana. The highest bid is what dealerships are at most willing to pay for your vehicle.",
    "content-22": "Due to data restrictions, the displayed time on the interface may vary by a second. We recommend not waiting until the last seconds to send messages or bids.",
    "content-23": "In competitions and negotiations, we use the official time of our service to ensure that all parties have the same time, independent of their device's date and time settings.",
    "content-3": "Competition in Baana ensures that you get the best price for your car, motorcycle or other vehicle – quickly and effortlessly. When you sell to a dealership, the deal is handled reliably: the dealership evaluates your vehicle expertly and takes care of all the paperwork for you. Your task? Choose the best offer!",
    "content-4": "A car can be sold on Baana if it is registered in Finland and has been driven no more than 250,000 km. A motorcycle, moped, ATV, moped car, scooter or snowmobile is suitable for Baana if it is registered in Finland and has been driven no more than 100,000 km.",
    "content-5": "No, quite the opposite. Our service guides you through all aspects of posting an ad and tells you what information to add and what kind of photos are needed for the listing. Submitting a listing takes less than ten minutes.",
    "content-6": "A vehicle sale auction on Baana lasts a few hours with express auction and about 48 hours with a regular auction. The auction ends two business days after the listing is published, between 10 AM and 5 PM. Buyer dealerships can place offers from when the listing is published until the auction ends. You will see the exact end time once your listing is published.",
    "content-7": "You are not committed. If you are not satisfied with the offers, you can reject them or negotiate with the bidders.",
    "content-8": "Yes, selling a vehicle owned by a finance company is just as easy as selling one you own yourself. The dealership deducts the remaining debt from the sale price, and you do not need to worry about it. If the remaining debt is higher than the sale price, you can pay the excess directly to the dealership. Some dealerships can also finance the remaining amount if the remaining debt exceeds the vehicle value. {{link1}}",
    "content-9": "We fetch your vehicle basic details using the registration number. You only need to provide the mileage, add photos and give a few additional details, e.g. about tire condition and service history.",
    "content-24": "A car's value consists of its model, make, model year, demand, and vehicle-specific factors such as condition, mileage, and accessories. If a car has many accessories and low mileage, its resale price will be higher than if it needs a lot of repairs and the model is not popular at the time of sale.",
    "content-25": "When you compete for car dealership offers in Baana, you'll receive a price estimate for your car when submitting your listing. The car price estimate is based on statistics collected by Nettiauto from car sales.",
    "content-26": "It's better to put the better tires as rear tires. If the car has the same tire size in front and back, it's good to rotate the tires so they wear evenly. If you drive moderate amounts, you can do the rotation during seasonal tire changes. For example, move the previous winter's front tires to the rear for the next winter.",
    "content-27": "The most important feature of a tire is sufficient and good tread. The tire should wear evenly across its entire width.",
    "content-28": "The purpose of tire tread grooves in winter and summer relates to driving safety. Sufficient tread depth ensures that water can escape from under the tires and prevents hydroplaning.",
    "content-29": "Car tire treads must be deep enough to function properly in different driving conditions and ensure safe driving.",
    "content-30": "By law, summer tires must have a minimum tread depth of 1.6 mm.",
    "content-31": "By law, winter tires must have a minimum tread depth of 3 mm in the main grooves.",
    "content-32": "Driving is safer when tires are in good condition. With good tires, the car behaves as it should and is easy to control. For example, a car can more easily hydroplane if the tire tread grooves aren't deep enough. As tires age, they harden and their driving characteristics deteriorate.",
    "content-33": "The car's electronic service book is stored in the manufacturer's own system. If you service your car somewhere other than an authorized dealer, check that the shop has access to the service book and updates it. You can request an up-to-date extract from the electronic service book during servicing.",
    "content-34": "The electronic service book can be found in the manufacturer's system, but a paper service book can unfortunately be lost. Be prepared that a lost service book may affect the car's resale and asking price if completed services and the car's history cannot otherwise be verified.",
    "content-35": "Yes, it can be sold as long as all estate heirs consent to the sale.",
    "content-36": "The car can remain in the estate's name as long as the estate hasn't been divided, and there's no exact time limit in the law.",
    "content-37": "Yes, but the sale requires a family investigation and consent from all heirs.",
    "content-38": "A finance company-owned car can be sold through Baana just like a personally owned car. The dealership pays off the remaining debt to the finance company and handles the related paperwork. The remaining debt amount is deducted from the sale price.",
    "content-39": "Yes, the car's holder can sell the car. When a finance company owns the car, you as the holder can compete for purchase offers from dealerships and sell the car through Baana. The purchasing dealership handles paying off the remaining debt to the finance company and transferring ownership. The remaining car loan is deducted from the purchase price paid to you.",
    "content-40": "Yes, you can sell a car even if it still has financing remaining. When selling through Baana, you don't need to worry about whether financing could be an obstacle - you can sell the car just like a personally owned car. A financed car can be sold to a dealership simply by having the dealership handle paying off the remaining loan to the finance company and transferring ownership to themselves. The necessary paperwork is handled at the dealership, and the remaining debt is deducted from the purchase price that the dealership pays you.",
    "content-41": "A car's value consists of its model, make, model year, demand, and vehicle-specific factors such as condition, mileage, and accessories. If a car has many accessories and low mileage, its resale price will be higher than if it needs a lot of repairs and the model is not popular at the time of sale.",
    "content-42": "When you compete for car dealership offers in Baana, you'll receive a price estimate for your car when submitting your listing. The car price estimate is based on statistics collected by Nettiauto from car sales.",
    "content-43": "Even if the remaining debt exceeds the vehicle's value, you can still sell your vehicle on Baana. Our partner Etua offers the opportunity to compare loan offers to pay off the remaining debt. {{link1}}",
    "content-44": "You need the estate inventory, heirs' consent, and registration certificate part II. Registration is done at an inspection station or insurance company.",
    "content-45": "The electronic service book is visible in the car manufacturer's or service network's web service, usually with the registration number or vehicle identification number (VIN).",
    "content-46": "Car services can be seen in the service book – either paper or electronic – and possibly in the service shop's system if services have been done at a brand dealership.",
    "content-47": "A complete service book means that all car services have been documented on time and comprehensively, without missing entries.",
    "content-202311291": "A car's value consists of its model, make, model year, demand, and vehicle-specific factors such as condition, mileage, and accessories. If a car has many accessories and low mileage, its resale price will be higher than if it needs a lot of repairs and the model is not popular at the time of sale.",
    "content-202311292": "When you compete for car dealership offers in Baana, you'll receive a price estimate for your car when submitting your listing. The car price estimate is based on statistics collected by Nettiauto from car sales.",
    "faq-title": "Frequently Asked Questions",
    "link-4-1": "On Nettiauto",
    "link-4-2": "On Nettiauto",
    "title-1": "How much does using the service cost?",
    "title-10": "Which dealerships buy vehicles through Baana?",
    "title-11": "I'm unable to publish the listing or I made an incorrect listing, what should I do?",
    "title-12": "How do I assess the condition of my tires?",
    "title-13": "How do I assess the condition of my windshield?",
    "title-14": "Should I service or repair my vehicle before selling?",
    "title-15": "What does it mean: How far am I willing to deliver my vehicle?",
    "title-16": "How do I upload photos to the service?",
    "title-17": "Can I leave the listing filling process unfinished?",
    "title-18": "I accepted a dealership offer, why have I not heard from them yet?",
    "title-19": "What if I'm not satisfied with the offers I received?",
    "title-2": "How can I know the value of my car, motorcycle, moped, scooter, ATV or caravan?",
    "title-20": "Is it worth selling a relatively new car, motorcycle, moped or other vehicle to a dealership?",
    "title-21": "What's the difference between trade-in value and cash difference? / Can I trade in my car, motorcycle or other vehicle to a dealership by selling it through Baana?",
    "title-22": "Why did it appear that the bidding or negotiation time was still left, but in reality, it had already ended, and I couldn't take any further actions?",
    "title-23": "Why does the bidding and negotiation time not match with my device's local time?",
    "title-3": "Why is it worth selling a car through Baana?",
    "title-4": "What kind of vehicle is suitable for sale on Baana?",
    "title-5": "Is it difficult to create a listing?",
    "title-6": "How long does the auction last?",
    "title-7": "Am I committed to selling my vehicle?",
    "title-8": "Is it possible to sell a financed car, motorcycle, or other financed vehicle to a dealership?",
    "title-9": "What information do I need to create a listing?",
    "title-24": "How is a car's value determined?",
    "title-25": "How do I get a car price estimate?",
    "title-26": "Should I put better tires on the front or back?",
    "title-27": "What kind of tread depth should a passenger car tire have?",
    "title-28": "What is the purpose of tire tread grooves in winter and summer?",
    "title-29": "Why is there a minimum tread depth requirement for tires?",
    "title-30": "What is the minimum allowed tread depth for summer tires?",
    "title-31": "What is the minimum allowed tread depth for winter tires?",
    "title-32": "How does tire condition affect vehicle handling?",
    "title-33": "Where can I find the car's electronic service book?",
    "title-34": "Lost car service book - what to do?",
    "title-35": "Can an estate car be sold?",
    "title-36": "How long can a car be in the estate's name?",
    "title-37": "Can the deceased's car be sold before the estate inventory?",
    "title-38": "How to sell a finance company's car?",
    "title-39": "Can a car's holder sell the car?",
    "title-40": "Can I sell a car that still has financing remaining?",
    "title-41": "How is a car's value determined?",
    "title-42": "How do I get a price estimate for my car?",
    "title-43": "What if the remaining loan balance is higher than the vehicle's value?",
    "title-44": "How do I get the estate car in my own name?",
    "title-45": "How to see the electronic service book?",
    "title-46": "Where can you see car services?",
    "title-47": "What does a complete service book mean?",
    "title-202311291": "How is a car's value determined?",
    "title-202311292": "How do I get a price estimate for my car?",
    "title-56": "Is it better to sell a used car privately or to a dealership?",
    "content-56": "Selling privately often yields a higher price, but it takes more time and effort. Selling to a dealership is faster, and the dealership handles the paperwork.",
    "title-57": "How long does selling a used car on Baana take?",
    "content-57": "Competitive bidding among dealerships usually lasts about two days from when the listing is published. With express bidding, a buyer can be found in less than a day.",
    "title-58": "Does selling a used car through Baana cost anything?",
    "content-58": "No, competitive bidding is free of charge and does not commit you to selling the car even if you receive offers.",
    "title-59": "Can I calculate a car's value myself without a calculator?",
    "content-59": "Yes, comparing your car to similar listings gives you a rough idea. The most accurate estimate, however, comes from a real competitive bidding among dealerships on Baana.",
    "title-60": "Is a car service book mandatory when selling a car?",
    "content-60": "A service book is not required by law, but it is always worth attaching it to the listing. A service book increases buyer trust and can raise the offer you receive.",
    "title-61": "Is it better to sell an old car to a dealership or privately?",
    "content-61": "Selling to a dealership is faster, and the dealership handles the paperwork. Selling privately can yield a better price, but it takes more time.",
    "title-62": "Can I sell a high-mileage or old car on Baana?",
    "content-62": "Yes, as long as the mileage is at most 250,000 km. The age of the car does not matter.",
    "title-63": "How do I know what my old car is worth?",
    "content-63": "An old car's value depends on make and model as well as age, mileage and condition. You can calculate the value with Baana's price estimate. The estimate is based on Nettiauto statistics of similar cars sold. You can get a price estimate when creating a listing on Baana.",
    "title-64": "What is the cash difference in a car deal?",
    "content-64": "The cash difference is the amount left to pay when the old car's value is deducted from the new car's price. It is paid to the dealership when the old car is traded in for a new one.",
    "title-65": "Is the cash difference the same as trade-in value?",
    "content-65": "Not quite. Trade-in value is the amount offered for the old car, while the cash difference is the remaining amount to pay. In practice both describe the same trade-in process from different angles.",
    "title-66": "Is it better to pay the cash difference or sell the old car separately?",
    "content-66": "Paying the cash difference is the easiest and fastest option when everything is handled through one dealership. Then you are, however, dependent on that dealership's offer for your old car. Selling separately, for example by competing offers on Baana, can often get you a better price for the old car.",
    "title-67": "Why compete the car sale on Baana?",
    "content-67": "Competing the car sale is the most effective way to secure the best possible selling price when you sell to a dealership. Baana competes all key dealerships in Finland for you. A dealership is a reliable and expert buyer that handles all paperwork for you and often also picks up the car. On Baana you can receive dealership purchase offers within a day, and competing the sale does not require you to accept an offer.",
    "title-202504011": "When will I see the offers I received?",
    "content-202504011": "You will see the offers with their prices only after the bidding time has ended.",
    "title-202504013": "There is already a listing with my registration number, what should I do?",
    "content-202504013": "There is likely a draft listing with this registration number under a different email address than the one you are currently using to submit the listing. Log in to Baana with the email address you used to create the original listing. After logging in, you can continue editing the draft from My auctions and finalize the listing.",
    "content-48": "Yes. However, describe any faults as comprehensively as possible in the listing so the dealership can estimate how much repairs would cost.",
    "content-49": "Yes, as long as the company line of business is not defined as retail trade of passenger cars and light motor vehicles. Remember to add the note VAT deductible to the listing if the condition is met.",
    "content-50": "Yes. You can easily republish the auction from My auctions.",
    "content-51": "You can. Using Baana does not obligate you to anything.",
    "content-52": "No worries. You can contact our customer service by email at asiakaspalvelu@almamobility.fi.",
    "content-53": "The buyer dealership handles all payments and necessary paperwork related to the deal. All you need to do is wait for the buyer to contact you. After contact, the dealership will give you more detailed information about the next practical steps. Buyers operating through Baana are pre-verified and trusted partners. Deals have gone smoothly in the service safely and without payment-related problems.",
    "content-54": "The dealership will agree on a suitable handover time with you. If you have chosen an offer that includes pickup, the dealership will collect the vehicle directly from your preferred location.",
    "content-55": "The reason is DAC7, which is an EU tax directive. The directive requires online platforms like Baana to report information about their customers' sales ({{link1}}).",
    "link-2-1": "How does a dealership determine your car price?",
    "link-8-1": "Read more about selling a financed car",
    "link-43-1": "Compare loan offers on Etua's website",
    "link-55-1": "read more about the DAC7 directive",
    "title-48": "Can I sell a faulty vehicle?",
    "title-49": "Can a company sell a vehicle?",
    "title-50": "Can I republish my listing?",
    "title-51": "Can I still cancel the sale of my vehicle?",
    "title-52": "I did not have time to respond to the offers in time, what should I do?",
    "title-53": "When will I receive payment for the vehicle I sold?",
    "title-54": "How does the vehicle handover take place?",
    "title-55": "Why am I asked for my personal identity code when accepting an offer?"
  },
  "faqPage": {
    "howToVideoTitle": "Baana - How to compete for offers for your car on Baana",
    "leavingAd": {
      "item1": {
        "title": "Is it difficult to create a listing?",
        "content": "No, quite the opposite. Our service guides you through all aspects of posting a listing and tells you what information to add and what kind of photos are needed for the listing. Submitting a listing takes less than ten minutes."
      },
      "item2": {
        "title": "There is already a listing with my registration number, what should I do?",
        "content": "There is likely a draft listing with this registration number under a different email address than the one you are currently using to submit the listing. Log in to Baana with the email address you used to create the original listing. After logging in, you can continue editing the draft from 'My auctions' and finalize the listing."
      },
      "item3": {
        "title": "How do I upload photos to the service?",
        "content": "A phone camera is perfectly fine for taking pictures. The service will tell you which parts of the vehicle need photos and guide you in taking them. If your vehicle has something special, like damages, we recommend taking additional photos. The more comprehensively the vehicle is photographed, the better understanding the dealership will get of it. Remember to also take photos of the service book."
      },
      "item4": {
        "title": "How do I assess tire condition?",
        "content": "A traditional way to test your vehicle's tire condition is to place a two-euro coin in the tire tread. You can also take close-up photos of your tires for your listing, allowing the dealership to assess their condition."
      },
      "item5": {
        "title": "How do I assess windshield condition?",
        "content": "Windshields can get stone chips or, in the worst case, crack. Such damage is visible to the naked eye. A visual evaluation of the windshield's condition is sufficient."
      },
      "item6": {
        "title": "What does it mean: How far am I willing to deliver my vehicle?",
        "content": "After the deal, the vehicle handover can be done either by having the vehicle picked up or by delivering it to the dealership yourself. This information is in the listing for dealerships so they can prepare for possible pickup costs when making an offer. If you are willing to deliver the vehicle to the dealership yourself, you will likely get a slightly better price."
      },
      "item7": {
        "title": "Can I republish my listing?",
        "content": "Yes. You can easily republish the auction from \"My auctions\"."
      }
    },
    "auctionInProgress": {
      "item1": {
        "title": "When will I see the offers I received?",
        "content": "You will see the offers with their prices only after the bidding time has ended."
      },
      "item2": {
        "title": "How long does the auction last?",
        "content": "A vehicle sale auction on Baana lasts a few hours with express auction and about 48 hours with a regular auction. The auction ends two business days after the listing is published, between 10 AM and 5 PM. Buyer dealerships can place offers from when the listing is published until the auction ends. You will see the exact end time once your listing is published."
      }
    },
    "afterAuction": {
      "item1": {
        "title": "What if I'm not satisfied with the offers I received?",
        "content": "If you are not satisfied with the offers you received, start a negotiation with your chosen dealership using \"start negotiation\". In a negotiation, each party can send a total of 10 messages. The aim is to agree on a sale price so that the vehicle sale goes through."
      },
      "item2": {
        "title": "Can I still cancel the sale of my vehicle?",
        "content": "You can. Using Baana does not obligate you to anything."
      },
      "item3": {
        "title": "I accepted a dealership's offer, why haven't I heard from them yet?",
        "content": "The dealership will contact you soon after you have accepted the offer. Please note that buyers may not be working on weekends, so contact may in some cases be delayed until the following week. If you still don't hear from the dealership, you can contact us by email at asiakaspalvelu@almamobility.fi."
      },
      "item4": {
        "title": "I didn't have time to respond to the offers in time, what should I do?",
        "content": "No worries. You can contact our customer service by email at asiakaspalvelu@almamobility.fi."
      },
      "item5": {
        "title": "When will I receive payment for the vehicle I sold?",
        "content": "The buyer dealership handles all payments and necessary paperwork related to the deal. All you need to do is wait for the buyer to contact you. After contact, the dealership will give you more detailed information about the next practical steps. Buyers operating through Baana are pre-verified and trusted partners. Deals have gone smoothly in the service safely and without payment-related problems."
      },
      "item6": {
        "title": "How does the vehicle handover take place?",
        "content": "The dealership will agree on a suitable handover time with you. If you have chosen an offer that includes pickup, the dealership will collect the vehicle directly from your preferred location."
      },
      "item7": {
        "title": "Why am I asked for my personal identity code when accepting an offer?",
        "content": "The reason is DAC7, which is an EU tax directive. The directive requires online platforms like Baana to report information about their customers' sales ({{link1}}).",
        "link": "read more about the DAC7 directive"
      }
    }
  },
  "auctionAdditionalInfo": {
    "title": "Additional Information",
    "addLabel": "Add details to your listing",
    "historyTitle": "Modification history",
    "placeholder": "Write additional information, for example clarifications about the vehicle's condition or equipment",
    "submit": "Add information",
    "success": "Additional information saved successfully",
    "error": "Failed to add additional information",
    "emptyMessage": "Please add either text or images",
    "addedAt": "Added at",
    "badge": "MODIFIED",
    "tooltip": "Additional information has been added to the listing",
    "addImages": "Add images",
    "imageSelected": "image selected",
    "imagesSelected": "{{selected}}/{{remaining}} images selected",
    "uploading": "Uploading images...",
    "submitting": "Submitting...",
    "uploadError": "Failed to upload images",
    "saveDetails": "Save details"
  },
  "general": {
    "add": "Add",
    "address": "Address",
    "at": "at",
    "city": "City",
    "country": "Country",
    "auctions": "Auctions",
    "back": "Back",
    "bid": "Bid",
    "bids": "Bids",
    "cancel": "Cancel",
    "canceled": "Canceled",
    "close": "Close",
    "companies": "Businesses",
    "confirm": "Confirm",
    "contactInfo": "Contact information",
    "create": "Create",
    "decline": "Decline",
    "delete": "Delete",
    "deleted": "Deleted",
    "edit": "Edit",
    "email": "Email",
    "eurLong": "{{amount}} euros",
    "faq": "Frequently asked questions",
    "includesVAT": "(incl. VAT 24%)",
    "hasNewMessage": "You have received a new message",
    "loadMore": "Load more",
    "loading": "Loading...",
    "loggingIn": "Logging in...",
    "login": "Login",
    "loginWithMicrosoft": "Login with Microsoft credentials",
    "loginAndContinue": "Login and continue",
    "loginPopupOpenTitle": "The login window is open in your browser",
    "loginPopupOpenMessage": "Sign in there to continue. If you don't see the window, check your browser's tabs.",
    "loginShort": "Login",
    "loginAlmaYritystunnus": "Login with Alma business credentials",
    "logout": "Logout",
    "month": "Month",
    "none": "None",
    "months": {
      "january": "January",
      "february": "February",
      "march": "March",
      "april": "April",
      "may": "May",
      "june": "June",
      "july": "July",
      "august": "August",
      "september": "September",
      "october": "October",
      "november": "November",
      "december": "December"
    },
    "municipality": "Municipality",
    "name": "Name",
    "next": "Next",
    "no": "No",
    "noBids": "No bids",
    "noMatchingAuctions": "No auctions",
    "ok": "Ok",
    "open": "Open",
    "phoneNumber": "Phone number",
    "pieces": "pcs",
    "postalCode": "Postal code",
    "previous": "Previous",
    "publish": "Publish",
    "registerConsumer": "Create Alma account",
    "registerDealer": "Create Alma business account",
    "returnToSummary": "Return to summary",
    "save": "Save",
    "saveAsDraft": "Save as draft",
    "saveAsDraftUnauthenticated": "Save as draft",
    "showAll": "Show all",
    "showMore": "Show more",
    "showAuction": "Show listing",
    "somethingWentWrong": "Something went wrong. Please try again later.",
    "streetAddress": "Street address",
    "today": "Today",
    "unknownRegistrationNumber": "Unknown registration number",
    "unnamedUser": "Unnamed user",
    "update": "Update",
    "users": "Users",
    "userSettings": "User Settings and pricing",
    "year": "Year",
    "yes": "Yes",
    "pageNotFound": "The requested page was not found.",
    "car": "car",
    "motorcycle": "motorcycle",
    "caravan": "caravan",
    "vehicle": "vehicle",
    "backToHome": "Back to home",
    "backToBlog": "Back to articles",
    "retry": "Retry",
    "errorTitle": "Something went wrong",
    "notFoundTitle": "Page not found",
    "eur": "{{amount}} €"
  },
  "menus": {
    "ownAuctions": "My auctions",
    "toConsumerView": "For consumers",
    "toDealerView": "For dealers"
  },
  "contactInfoContent": {
    "contactTitle": "Contact Information",
    "customerServiceTitle": "Customer Service",
    "businessCustomerServiceHeading": "Customer service for businesses",
    "businessCustomerServiceIntro": "Open weekdays 9 AM–4 PM ┃ Mobile or local network charge.",
    "businessCustomerServicePhone": "<a class='phone-link' href='tel:+358102311710'>010 231 1710</a>",
    "businessCustomerServiceEmail": "<a class='email-link' href='mailto:yritykset@almamobility.fi'>yritykset@almamobility.fi</a>",
    "privateCustomerServiceHeading": "Customer service for private customers",
    "privateCustomerServiceHours": "Open weekdays 9 AM–4 PM, Sat–Sun 11 AM–3 PM┃ €0.38/min + local network charge",
    "privateCustomerServicePhone": "<a class='phone-link' href='tel:060004070'>060 004 070</a>",
    "privateCustomerServiceEmail": "<a class='email-link' href='mailto:asiakaspalvelu@almamobility.fi'>asiakaspalvelu@almamobility.fi</a>",
    "contactsTitle": "Contact Persons",
    "customerServiceContact": "Customer Service",
    "customerServiceEmail": "<a class='email-link' href='mailto:asiakaspalvelu@almamobility.fi'>asiakaspalvelu@almamobility.fi</a>",
    "businessOwnerContact": "Ville Vähämaa",
    "businessManager": "Business Manager",
    "managerContact": "Atte Hämäläinen",
    "manager": "Development Manager"
  },
  "feedbackForm": {
    "title": "Contact us",
    "fields": {
      "email": "Email",
      "name": "Name",
      "mobile": "Mobile phone number",
      "subject": "Feedback subject",
      "message": "Message",
      "attachments": "Attachments",
      "attachmentHelper": "You can attach screenshots or photos. Images are automatically optimised before sending."
    },
    "subjectOptions": {
      "consumer": {
        "postingAd": "Posting an ad",
        "login": "Logging in",
        "registration": "Registering",
        "otherFeedback": "Other feedback and advice"
      },
      "dealer": {
        "businessInfoChanges": "Changes in business information",
        "technicalError": "Technical error",
        "newCustomer": "New customer",
        "otherFeedback": "Other feedback and advice"
      },
      "technicalError": "Technical error"
    },
    "validation": {
      "requiredEmail": "Email is required",
      "invalidEmail": "Please check the email format",
      "requiredSubject": "Please select a feedback subject",
      "requiredMessage": "Message is required",
      "messageTooLong": "Message cannot exceed {{max}} characters"
    },
    "buttons": {
      "send": "Send",
      "clear": "Clear"
    },
    "success": "Thank you for your feedback!",
    "successTitle": "Feedback sent!",
    "successMessage": "Thank you for your feedback. We will contact you as soon as possible.",
    "sendNewFeedback": "Send new feedback",
    "viewImage": "View image",
    "removeFile": "Remove file",
    "error": {
      "badRequest": "Please check your form data.",
      "unauthorized": "Please log in again.",
      "forbidden": "Access denied.",
      "unprocessable": "Form data is invalid.",
      "rateLimit": "Too many requests. Please try again later.",
      "generic": "Something went wrong. Please try again later.",
      "fileTooLarge": "The following files are too large (max {{max}} MB): {{files}}",
      "imageUploadPartial": "Some images failed to upload. Please try resending them.",
      "imageUploadFailed": "Failed to upload image \"{{filename}}\". Please try again.",
      "maxImagesReached": "Maximum {{max}} images allowed."
    },
    "progress": {
      "sending": "Sending...",
      "uploadingImage": "Uploading image {{current}}/{{total}}...",
      "doNotRefreshWarning": "Please wait until all images are uploaded"
    }
  },
  "myAuctions": {
    "auctioned": "Auctioned",
    "acceptOffer": "Accept offer",
    "acceptOfferBody": "You are about to accept the following offer. Please review the details before accepting.",
    "addNewAuction": "Auction your car",
    "auctionDetails": "Your listing summary",
    "auctionHasEnded": "Auction has ended",
    "auctionHasEndedBody": "The auction has ended, and below you can see the offers you received for your car. You can decide whether to accept or decline any of the received offers.\n\nNote! If the highest offer is significantly below your target price, we still recommend starting negotiations with the dealership. They might be willing to increase their offer.",
    "auctionTimeEnded": {
      "title": "Did time run out?",
      "body": "If you didn't manage to make a deal with the buyer, please contact our customer service.",
      "button": "Customer service contact information"
    },
    "allBidsDeclinedSuccess": "All offers declined successfully.",
    "bidDeclinedSuccess": "Bid declined successfully.",
    "buyerDistance": "Buyer's distance",
    "continueDraft": "Continue filling the listing",
    "continueDraftHeader": "Continue draft",
    "declineAllOffers": "Decline all offers",
    "declineOffer": "Decline offer",
    "endedAuctionsHeader": "Ended auctions",
    "endedNegotiation": "Ended negotiations",
    "offer": "Offer",
    "me": "Me",
    "dealership": "Dealership",
    "unfinishedDraftDialog": {
      "title": "Unfinished {{vehicleType}} listing",
      "message": "You have an unfinished {{vehicleDialogText1}} listing. Do you want to continue with the unfinished draft or create a new {{vehicleDialogText2}} listing?",
      "continueDraft": "Continue draft",
      "createNewAuction": "Create new listing",
      "createNewWillDelete": "Note: Creating a new listing will delete the current draft.",
      "loading": "Loading..."
    },
    "publishedAuctionDescription": "Car dealerships can now make bids on your car. Note! Published listings cannot be edited because changes can invalidate existing bids. If you have made an error in your listing, please contact our customer support",
    "support": "<a class='phone-link' href='tel:0600-04070'>0600-04070</a> or <a class='email-link' href='mailto:asiakaspalvelu@almamobility.fi'>asiakaspalvelu@almamobility.fi</a>",
    "hasDraftAuctionDescription": "Your auction is in progress. You can continue filling it.",
    "hasDraftAuctionHeader": "Unfinished listing",
    "draftAuction": "Draft auction",
    "isFetchingAuctions": "Fetching auctions...",
    "hasErrorWithFetching": "An error occurred while fetching the listings. Please try again later.",
    "hasErrorWithRemoval": "An error occurred while removing the listing. Please try again later.",
    "header": "My auctions",
    "highTargetPriceWarning": "Target price differs significantly from price estimate. A high target price may make selling more difficult.",
    "infoMessage": "has received your contact information and will get in touch with you as soon as possible. This ensures that you will directly communicate with the right person at the correct dealership.",
    "messageSenderDealer": "Dealership",
    "messageSenderMe": "Me",
    "myMessageNumber": "Message",
    "negotiation": "Negotiation",
    "active": "Active",
    "history": "History",
    "negotiationDescription": "You can negotiate with the dealership that made the offer by sending them a message. When the negotiation with the dealership is ongoing, each new message resets the negotiation time to 30 hours.",
    "negotiationErrorFetchingAuction": "Error fetching auction information.",
    "negotiationErrorFetchingMessages": "Error fetching messages.",
    "negotiationMessageLimit": "Please note that the discussion is limited to ten messages per party, and dealerships typically respond during office hours.",
    "negotiationMessageLimitReached": "You have used all your allocated message count. If the discussion with the buyer was significantly cut short, please contact Baana customer support. Please remember to accept the offer if the negotiation led to the desired outcome.",
    "negotiationMessageDisabled": "This is a negotiation with another representative from the same car dealership. Sending messages is disabled.",
    "negotiationAcceptModal": {
      "title": "Accept offer",
      "body": "You are about to accept an offer for {{amount}} €. Are you sure you want to accept this offer?"
    },
    "negotiationDeclineModal": {
      "title": "Decline offer",
      "body": "Are you sure you want to decline the offer of {{amount}} € without trying to negotiate? In negotiation, you can propose a price at which you would be willing to sell your vehicle."
    },
    "negotiationSendMessageError": "Error sending the message.",
    "noAuctions": "You don't have any active auctions.",
    "noOffersReceived": "No offers received for the item.",
    "numberOfBids": "Bids",
    "offerAcceptedDescription": "You have successfully accepted the selected offer.",
    "offerAcceptedContent": {
      "alert": "You have accepted the offer!",
      "header1": "What happens next?",
      "body1": "The dealership that made the offer will contact you at {{phoneNumber}} or {{email}} as soon as possible, at the latest within a few days.",
      "body1-2": "Note: You should agree on the handover to the dealership as soon as possible.",
      "header2": "What if the dealership doesn't contact me?",
      "body2": "If the dealership has not contacted you within a few days, please contact our ",
      "link2": "customer support."
    },
    "newBids": "NEW BIDS",
    "newQuestions": "NEW QUESTIONS",
    "bids": "bids",
    "questions": "questions",
    "updated": "Updated",
    "days": "days",
    "offersVisibleAfterAuction": "The offer amounts will be visible only after the auction ends!",
    "offersComingInBackground": "During the auction you can see the number of offers and bidders.",
    "auctionInProgress": "Auction in progress!",
    "auctionInProgressDescription": "Dealers can make offers for your vehicle until the bidding period ends.",
    "needHelp": {
      "prefix": "You can add information to your listing",
      "additionalInfoLink": "here",
      "middle": ". You can also contact our",
      "contactLink": "customer service",
      "suffix": "."
    },
    "contactCustomerService": "customer service",
    "offerNegotiations": "Negotiation for offer",
    "pickUpIncluded": "Pickup included",
    "priceEstimate": "Target price",
    "priceEstimateAbove": "Above target",
    "priceEstimateBelow": "Not above target",
    "readTipsForGoodAuctionAd": "Lue vinkit hyvän ilmoituksen tekemiseen",
    "rejectOffer": "Reject offer",
    "rejectOfferBody": "Are you sure you want to reject the following offer?\n\nA rejected offer cannot be accepted, and negotiations with the dealership who made the offer will not be possible.",
    "rejectOfferHeader": "Rejecting the offer",
    "remainingTime": "Time remaining",
    "removeAuction": "Remove listing",
    "removeAuctionModalBody": "If you remove the listing, you won't be able to continue filling it later, it will be permanently deleted.",
    "removeAuctionModalTitle": "Are you sure you want to remove the listing?",
    "selectedOffer": "Selected offer",
    "selectedBid": "Selected bid",
    "selectedBidAmount": "Bid amount",
    "sendMessage": "Send message",
    "showNegotiation": "Show negotiation",
    "startNegotiation": "Start negotiation",
    "originalOfferRank": "{{originalOfferRank}}. highest bid",
    "sumOfOffer": "Offer amount",
    "targetPriceReached": "Price now",
    "timeToFinishDeal": "Time left to finalize the deal",
    "timeToAcceptOffer": "Time to accept offer",
    "inNegotiation": "In negotiation",
    "pendingOffer": "Pending",
    "targetInformation": "Kohteen tiedot",
    "topOffers": "Top offers",
    "totalBidCount": "Bids",
    "winningBid": "Highest offer",
    "writeMessage": "Write message",
    "whatHappensNext": "What happens next?",
    "whatHappensNextBody": "Next, the dealership will contact you to arrange the handover of the car. Note that you must agree on the handover as soon as possible.\n\nIf the dealership has not contacted you within 24 business hours, please contact our customer service for assistance."
  },
  "emailVerification": {
    "title": "Welcome",
    "paragraph1": "You have created a {{userType}} account with {{email}}.",
    "paragraph2": "Please verify your email address to start using the Baana service.",
    "paragraph3": "Instructions for verification have been sent to your email.",
    "paragraph4": "Didn't receive the message?",
    "link": "Request a new verification email",
    "almaAccount": "Alma Account",
    "almaBusinessAccount": "Alma Business Account",
    "verified": "Verified"
  },
  "notifications": {
    "addNoteFailure": "Failed to add the note!",
    "addNoteSuccess": "Note added successfully.",
    "auctionAccepted": "The seller accepted your bid for {{targetVehicleInfo}}.",
    "auctionCancelled": "Auction for {{targetVehicleInfo}} has been cancelled.",
    "auctionEnded": "Auction for {{targetVehicleInfo}} has ended.",
    "biddingFailure": "Failed to place a bid!",
    "adminBidRemoved": "An admin has removed your bid on {{targetVehicleInfo}}.",
    "adminBidModified": "An admin has modified your bid on {{targetVehicleInfo}}.",
    "bidDeclined": "The seller declined your bid for {{targetVehicleInfo}}.",
    "bidFailedOtherBidMachineGotBid": "Your bid was not successful, as a competitor placed a bid with the same amount before you.",
    "bidMachineDeactivationFailure": "Failed to deactivate the bid machine!",
    "bidMachineDeactivationSuccess": "Bid machine successfully deactivated.",
    "bidMachineUpdateFailure": "Failed to update the bid machine!",
    "bidMachineUpdateSuccess": "Bid machine successfully updated.",
    "bidSuccess": "Bid successfully placed.",
    "bidSuccessOtherBidMachineRaised": "Your bid was successful, but a competitor's bid exceeded yours.",
    "createAuctionFailed": "You already have an active auction, you cannot create a new one at the moment.",
    "deleteNoteFailure": "Failed to delete the note!",
    "deleteNoteSuccess": "Note deleted successfully.",
    "editNoteFailure": "Failed to edit the note!",
    "editNoteSuccess": "Note edited successfully.",
    "emailNotVerified": "An email has been sent to you. Please verify your email address according to the instructions in the message. Next, sign out and then sign back in to get started with your ad!",
    "loginFailed": "Login failed.",
    "logoutFirst": "Please log out from the current view first.",
    "noAdminRights": "The user does not have admin rights.",
    "userNotVerified": "You will receive a message to your email when you are activated by Baana, and the bidding can begin.",
    "userMissingNameException": "Your Alma Account is missing some required information (first name, last name). Please update your information using the link below and try logging in again.",
    "userMissingNameExceptionDealer": "Your Alma Business Account is missing some required information. Please contact customer service to update your information.",
    "userMissingNameExceptionErrorMessage": "https://itsepalvelu.almamedia.fi/",
    "userRemovedSuccefully": "User {{firstName}} {{lastName}} has been removed from the service",
    "negotiationMessageSendingFailed": "Failed to send the negotiation message!",
    "withdrawOfferSuccess": "Offer withdrawn.",
    "withdrawOfferFailure": "Failed to withdraw the offer!",
    "markAsCompleteSuccess": "Deal marked as complete.",
    "markAsCompleteFailure": "Failed to mark the deal as complete!",
    "newBidsOutBidded": "Your bid for {{targetVehicleInfo}} has been outbid.",
    "newNegotiationMessage": "New negotiation message for {{targetVehicleInfo}}.",
    "newAnswerToQuestion": "New answer to your question about {{targetVehicleInfo}}.",
    "newQuestion": "New question",
    "questionDeletedSuccesfully": "Question deleted",
    "questionDeleteError": "Failed to delete the question",
    "questionAddedSuccessfully": "Question added",
    "questionAddError": "Failed to add the question",
    "offerSendError": "Failed to send the offer",
    "dac7AccountClosed": "Your account has been closed due to missing information. Please fill in your name, address, and personal identity code to reactivate your account.",
    "dac7AccountClosedWithDraft": "Your account has been closed due to missing information. Please fill in your name, address, and personal identity code to reactivate your account. Your listing draft has been saved — you will be taken to it after reactivation.",
    "newInstructionsAvailable": "New instructions or updates are available",
    "tooManyImages": "You can add a maximum of {{maxCount}} images at a time.",
    "maxImagesReached": "Maximum image limit reached. You cannot add more than {{maxCount}} images.",
    "tooManySectionImages": "You can add a maximum of {{maxCount}} images to this section at a time.",
    "maxSectionImagesReached": "Section image limit reached. You cannot add more than {{maxCount}} images to this section.",
    "maxImagesReachedButton": "Maximum number of images reached",
    "addImagesButton": "Add images",
    "uploadingImagesInProgress": "Uploading images…",
    "dragOrSelectImagesDescription": "Drag and drop images here, or select them from your device. Supported file types: JPG, PNG, WEBP, HEIC, HEIF",
    "someImagesFailedToUpload": "{{count}} image(s) failed to upload.",
    "allImagesFailedToUpload": "All images failed to upload. Please try again.",
    "autologinSuccess": "You have been logged in with Alma Account {{email}}",
    "reportAuctionSuccess": "Report sent to the admins.",
    "reportAuctionLimitReached": "You have already reported this auction the maximum number of times.",
    "reportAuctionFailure": "Sending the report failed!"
  },
  "socketMessages": {
    "newOfferReceived": "New offer.",
    "newMessageReceived": "New message.",
    "auctionHasEnded": "Auction has ended.",
    "offerAccepted": "Offer accepted.",
    "dealerOfferAccepted": "Dealer has marked the deal as preliminary deal",
    "rejectedByDealer": "Offer rejected by the dealer.",
    "dealCompleted": "Deal completed"
  },
  "analytics": {
    "vehicleType": {
      "car": "Car",
      "moto": "Motorcycle",
      "caravan": "Caravan"
    },
    "motoSubType": {
      "2": "Motorcycle",
      "5": "Moped",
      "6": "Snowmobile",
      "16": "ATV",
      "17": "Scooter",
      "19": "Moped car",
      "default": "Vehicle"
    }
  },
  "vehicleType": {
    "car": "Car",
    "moto": "Motorcycle",
    "caravan": "Caravan"
  }
}
